import {
  ChangeDetectorRef,
  Component,
  importProvidersFrom,
  Input,
  ViewChild,
} from "@angular/core";
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { SharedModule } from "../../../../shared/shared.module";
import { NxDialogService, NxModalRef } from "@aposin/ng-aquila/modal";
import { PdpaPopupComponent } from "../../../../popup/pdpa-popup/pdpa-popup.component";
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Store, Select } from '@ngxs/store';
import { STORE_DECLARATION, SEARCH_ACTIVE_QUOTATION, GET_PREVIOUS_POLICY_NO, GET_LOV, GET_PRODUCT_LIST, SEARCH_VIX, ROADTAX_SEARCH, SEARCH_ENDT_VEHICLE, COPY_CNGE_INFO, COPY_CNGE_INFO_RENEWAL, RESET_MOTOR_STATE, RESET_PREVIOS_POLICY_DETAILS, STORE_STEP2_CP_SCREEN, GET_CUSTOMER_PARTNER, STORE_STEP2_SEARCH, SHOW_SEARCH_COMPONENT_2, GET_POSTCODE_LOV, CALCULATE_PREMIUM, VALIDATE_POI_DATE, STORE_PREMIUM_CALCULATION_PAYLOAD, RESET_SUBSEQUENT_PAGE_DATA, SET_RETRIEVE_QUOTATION, ENDORSEMENT_TYPE_VALIDATION, UPDATE_ENDORSEMENT_STEP2, SET_PRODUCT_CODE_DESCRIPTION, STORE_AGENT_ADDITIONAL, CANCEL_DRAFT, GET_SWITCH_SITE, DELETE_COVERAGE, ACTIVE_SELECTION_POPUP, GET_NCD_ENQUIRY, GET_CCENTRIC_OPPORTUNITY_INFO, CCENTRIC_VEH_NOT_FOUND_POPULATE_DATA, SET_CCENTRIC_ISSUANCE_IND, UPDATE_COVERAGE_TYPE, STORE_EXTRA_COVER_DETAILS, STORE_EXTRA_COVER_SUMMARY, STORE_NCD_INFO, STORE_NCD_INFO_PDPA, UPDATE_ENDT_XP_VALIDATION, STORE_STEP3, PATCH_STEP3, STORE_ONE_ALLIANZ_DATA, STORE_DRIVER_DETAILS_SUMMARY, UPDATE_ACTIVE_QUOTATION, STORE_IS_CCENTRIC_CP_AUTO_SEARCH } from '@store/sat-motor/sat-motor.action';
import { IssueEndorsementValidationComponent } from "src/app/views/motor/endorsement/issue-endorsement-validation/issue-endorsement-validation.component";
import { EnquiryPopupComponent } from "../../../../popup/enquiry-popup/enquiry-popup.component";
import { PdpaComponent } from "@shared/components/declaration-issuance/pdpa/pdpa.component";
import { UserResponse } from "@interfaces/user";
import { OkMessageComponent } from "@shared/components/modal/ok-message/ok-message.component";
import { SatMotorState } from "@store/sat-motor/sat-motor.state";
import { PreviousPolicyErrorPopupComponent } from "@shared/components/modal/previous-policy-error-popup/previous-policy-error-popup.component";
import { ScrollToError } from "@shared/classes/scroll-to-error";
import { CLIENTTYPE, IDTYPE, COUNTRIES } from "@shared/enums/index.enum";
import { MyDateAdapter } from "@shared/helpers/date.adapter";
import { NxDateAdapter, NX_DATE_FORMATS } from "@aposin/ng-aquila/datefield";
import { DatePipe } from "@angular/common";
import { NxMomentDateModule } from "@aposin/ng-aquila/moment-date-adapter";
import moment from "moment";
import { debounceTime, distinctUntilChanged, first } from "rxjs/operators";
import { BACK_TO_ALPHA, REDIRECT_ALPHA_CCENTRIC } from "@store/user/user.action";
import { ConfirmationModalComponent } from "@shared/components/modal/confirmation-modal/confirmation-modal.component";
import { SimpleModalComponent } from "@shared/components/modal/simple-modal/simple-modal.component";
import { CpMandatoryFilledService } from "@shared/services/cp-mandatory-filled/cp-mandatory-filled.service";
import { NricService } from '@services/nric/nric.service';
import { SummaryPopupComponent } from "src/app/popup/summary-popup/summary-popup.component";
import { CancelDraftModalComponent } from "@shared/components/modal/cancel-draft-modal/cancel-draft-modal.component";
import { FormatDecimalPipe } from "@shared/pipes/format-decimal/format-decimal.pipe";
import { RemoveCommaPipe } from "@shared/pipes/remove-comma/remove-comma.pipe";
import { LoadingService } from "@shared/services/loading/loading.service";
import { Observable, Subscription, timer } from "rxjs";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: 'app-shared-issuance',
  standalone: true,
  imports: [
    SharedModule,
    IssueEndorsementValidationComponent,
    PdpaComponent,
    NxMomentDateModule
  ],
  providers: [
    { provide: NxDateAdapter, useClass: MyDateAdapter },
    { provide: NX_DATE_FORMATS, useValue: MY_FORMATS }, DatePipe],
  templateUrl: './issuance.component.html',
  styleUrl: './issuance.component.scss'
})
export class IssuanceComponent {

  @Select(SatMotorState.motorAgentDetail) agentDetail$;
  @Select(SatMotorState.motorStep1Issuance) issuanceData$;
  @Select(SatMotorState.endtStep1Issuance) endtIssuanceData$;
  @Select(SatMotorState.endtVehiclePolicy) endtVehicleData$;
  @Select(SatMotorState.commonLov) commonLov$;
  @Select(SatMotorState.motorActionType) actionType$;

  @Input() isIssuance: boolean = false;
  @Input() isEndorsement: boolean = false;
  @Input() isEnquiry: boolean = false;
  @Input() isRTP: boolean = false;

  private vehicleSearchTimeout: number | undefined;
  dialogRef?: NxModalRef<any>;
  componentDialogRef1?: NxModalRef<EnquiryPopupComponent>;
  componentDialogRef?: NxModalRef<PdpaPopupComponent>;
  componentDialogRefs?: NxModalRef<SummaryPopupComponent>;
  okMessageModal?: NxModalRef<OkMessageComponent>;
  okMessageEndtModal?: NxModalRef<OkMessageComponent>;
  openPreviousPolicyError?: NxModalRef<PreviousPolicyErrorPopupComponent>;
  confirmMessageModal?: NxModalRef<ConfirmationModalComponent>;

  popup_type: any;
  cn_quotation = true;
  isIndividual = true;
  agentData: any = {};
  previousPolicyNo: any;
  policyNo: any
  coverNoteTypeList: any;
  idTypeList: any;
  lov: any;
  productList: any;
  filteredProductList; any;
  endorsementList: any;
  isRTPDataExist: boolean = false;
  userInfo: any;
  endtPolicy: any;
  endtVehicleFound: boolean = false;
  previousExtension: boolean = false;
  showSpecialVehicle = false;
  isVehicleIdNoExist: boolean = false;
  previousPolicyDetails: any;
  activeQuotationDetails: any;
  issuanceInfo: any;
  updateQuotation: any;
  isRenewal: boolean = false;
  isActiveQuotation: boolean = false;
  isSingleAgent: boolean = false;
  cpDetails: any = {};
  isCompOrCustInfoIncomplete: boolean = false;
  isContactInfoIncomplete: boolean = false;
  isCorrespondenceInfoIncomplete: boolean = false;
  showDateValidateError: boolean = false;
  showEndtDateValidateError: boolean = false;
  showLapsedError: boolean = false;
  isCommercial: boolean = false;
  dateValidateError: any;
  issuanceStateData: any;
  queryParams: any;
  operator: any;
  endtPreviousPolicy: any;
  endtIssuanceData: any;
  cCentricInfo: any;
  clientDetails: any;
  isEffectiveDateValidation: boolean = false;
  isRequote: boolean = false;
  onlyNumber: boolean = false;
  isSaved: any;
  lovproductConfig:any;
  productAccessListData: any;
  lovPC : any;
  lovGeo: any;
  emailCheck : any;
  custAge : any;
  statePDPAData: any;
  isCMRedirection: boolean = false;
  enableCommercial: boolean = false;
  opportunityId: any;
  isCpStepExist: boolean = false;
  isCoverageStepExist: boolean = false;
  defaultEndtEffectiveDate: any;
  defaultEndtExpiryDate: any;
  nextButtonClicked: boolean = false;
  decimalFmt: any;
  numberFmt: any;
  isEndtLoading: boolean = false;
  isDraftRecord: boolean = false;
  isDataFromView: boolean = false;
  policyDetails: any;
  isFromCCentric: any;
  subscription: Subscription;
  isRNSearchComplete: boolean = false;
  isSecondSearchComplete: boolean = false;
  hasShownProductError: boolean = false;
  isEmarketingConsentEnabled: boolean;
  ccManualClickSatMenu: boolean = false;

  endorsement = true; ///////for functional IssueEndorsementValidationComponent

  isEinvoiceEnabled: boolean = false; //AGIC-45992 True to enable e-consent field.

  NCD_WO_NOTIFICATION = [
    "ENQ000", "ENQ014", "ENQ016", "ENQ017", "ENQ030", "ENQ044", "ENQ051", "ENQ057", "ENQ060", "ENQ062", 
    "ENQ063", "ENQ067", "ENQ078", "ENQ079", "ENQ080", "ENQ081", "ENQ088", "ENQ089", "ENQ092", "ENQ096"
  ];

  pdpaForm: FormGroup;
  public issuanceForm: FormGroup;

  idTypeProductMap = {
    "NRIC": ["080100", "082100", "082101"],
    "OLD_IC": ["080100", "082100", "082101"],
    "POL": ["080100", "082100", "082101"],
    "PASS": ["080100", "082100", "082101"],
    "NEW_BR_NO": ["080200", "080300", "082100", "082101"],
    "BR_NO": ["080200", "080300", "082100", "082101"]
  };

  vehicleUseProductMap = {
    "080100": "01",	//  PRIVATE CAR -PRIVATE USE (DRIVE TO WORK/DAILY USE)
    "080200": "02",	//	PRIVATE CAR FOR BUSINESS USE
    "080300": "02",	//	PRIVATE CAR FOR BUSINESS USE
    "082100": "11",	//	MOTORCYCLE - PRIVATE USE(ALL RIDER)
    "082101": "11",	//	MOTORCYCLE - PRIVATE USE(ALL RIDER)
  };

  idTypeConfig = {
    NRIC: {
      clientAddressType: COUNTRIES.MALAYSIAN,
      clientType: CLIENTTYPE.INDIVIDUAL
    },
    OLD_IC: {
      clientAddressType: COUNTRIES.MALAYSIAN,
      clientType: CLIENTTYPE.INDIVIDUAL
    },
    POL: {
      clientAddressType: COUNTRIES.MALAYSIAN,
      clientType: CLIENTTYPE.INDIVIDUAL
    },
    PASS: {
      clientAddressType: COUNTRIES.NON_MALAYSIAN,
      clientType: CLIENTTYPE.INDIVIDUAL
    },
    NEW_BR_NO: {
      clientAddressType: "",
      clientType: CLIENTTYPE.COMPANY
    },
    BR_NO: {
      clientAddressType: "",
      clientType: CLIENTTYPE.COMPANY
    }
  };

  constructor(
    private dialogService: NxDialogService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    public store: Store,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private cpMandatoryFilledService: CpMandatoryFilledService,
    private nricService: NricService,
    private readonly loadingService: LoadingService,

  ) {
    this.decimalFmt = new FormatDecimalPipe();
    this.numberFmt = new RemoveCommaPipe();
    this.pdpaForm = this.fb.group({
      pdpaCheck: new FormControl(false),
      consentDetails: this.fb.group({
        edocConsentInd: '',
        einvoiceConsentInd: '',
        emarketingConsentInd: ''
      })
    });
  }

  ngOnInit() {

    this.actionType$.subscribe((state) => {
      if (state) {
        this.isIssuance = state.isIssuance;
        this.isEndorsement = state.isEndorsement;
        this.isEnquiry = state.isEnquiry;
        this.isRTP = state.isRTP;
      }
    });

    this.isSingleAgent = this.store.selectSnapshot<any>((state) => state.SatMotorState.isSingleAgent);
    this.queryParams = this.store.selectSnapshot<any>((state) => state.UserState.queryParams);
    this.operator = this.store.selectSnapshot(state => state.UserState.user.userId);
    this.isCommercial = this.store.selectSnapshot<any>((state) => state.SatMotorState.opportunityId);
    this.opportunityId = this.store.selectSnapshot<any>((state) => state.SatMotorState.opportunityId);
    this.clientDetails = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step2);
    this.isCpStepExist = !!this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step2);
    this.isRequote = this.store.selectSnapshot<any>((state) => state.SatMotorState.requoteQuotation);
    this.isSaved = this.store.selectSnapshot<any>((state) => state.SatMotorState?.draftDetails);
    this.cCentricInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState?.cCentricInfo);
    this.isCoverageStepExist = !!this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3);
    this.isDraftRecord = this.store.selectSnapshot<any>((state) => state.SatMotorState.draftDetails);
    this.isDataFromView = this.store.selectSnapshot<any>((state) => state.SatMotorState.viewQuotation || state.SatMotorState.updateQuotation);
    this.isFromCCentric = this.queryParams?.opportunityId;
    this.isEmarketingConsentEnabled = this.store.selectSnapshot(SatMotorState.isEmarketingConsentEnabled);
    this.ccManualClickSatMenu = this.queryParams?.ccManualClickSatMenu;

    this.commonLov$.subscribe((state) => {
      if (state) {
        this.lov = state;
        this.productList = state.productList;
        this.endorsementList = state.endorsementList;
        if (this.isEndorsement && this.endorsementList && this.endtPolicy) {
          this.populateEndtFormData(this.endtIssuanceData);
          this.endtVehicleFound = true;
        }
      }
    });

    this.lovproductConfig = this.lov.productAccessConfigList;
    this.issuanceInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor?.step1?.issuance?.issuance);
    this.updateQuotation = this.store.selectSnapshot<any>((state) => state.SatMotorState?.updateQuotation);
    this.userInfo = this.store.selectSnapshot<UserResponse>(state => state.UserState.user);
    this.previousPolicyDetails = this.store.selectSnapshot<UserResponse>(state => state.SatMotorState.previousPolicyDetails);
    this.policyDetails = this.store.selectSnapshot<any>(state => state.SatMotorState.policyDetails);
    this.activeQuotationDetails = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor?.step1?.activeQuotation);
    if (this.activeQuotationDetails) {
      this.isActiveQuotation = true;
      if (this.activeQuotationDetails?.cngeNote?.cnoteType == 'RN') {
        this.isRenewal = true;
      }
    }

    if (this.isEndorsement) {
      this.isEndtLoading = true;
      this.loadEndorsement();
    }

    if (this.isIssuance) {
      this.loadIssuance();
    }

    if (this.isRTP) {
      this.loadRTP();
    }

    this.issuanceForm.get('productCode').valueChanges.subscribe(code => {
      this.updateProductDesc(code);
    });

    if (this.previousPolicyDetails?.previousPolicyNo) {
      this.loadPreviousPolicyDetails();
      this.isRenewal = this.verifyCnoteType?.() === 'RN';
    }

    //Renew from alpha portal
    if (this.queryParams.renewNow && this.queryParams.policyNo) {

      let param = {
        "policyNo": this.queryParams.policyNo,
        "agentCode": this.agentData.agentCode,
        "vehicleNo": this.queryParams.vehNo,
        "idNo": this.queryParams.idValue
      };

      this.searchActiveQuotation(param);
    }

    this.enableCommercial = this.lov?.enableCommercial ? this.lov.enableCommercial == "Y" : false;

    if(this.isCommercial){
      if(this.isEndorsement && !this.cCentricInfo) {
        const getCCentricInfoParam = {
          "opportunityId": this.opportunityId,
          "endorsement": true
        };
        this.store.dispatch(new GET_CCENTRIC_OPPORTUNITY_INFO(getCCentricInfoParam)).subscribe(state => {
          this.cCentricInfo = state.SatMotorState.cCentricInfo;
          this.loadCCentricDetails();
          this.onChangeVehicleNo('ccentric');
        });
      }else if(this.isIssuance){
        if(!this.isCpStepExist && !this.isCoverageStepExist) {
          let issuanceGetCCentricInfoParam = {
            "opportunityId": this.opportunityId,
            "agentCode": this.agentData.agentCode,
            "action": null
          };
          if(this.ccManualClickSatMenu) {
            issuanceGetCCentricInfoParam.action = 'CC_ISS_FROM_CN_MENU';
          }
          this.store.dispatch(new GET_CCENTRIC_OPPORTUNITY_INFO(issuanceGetCCentricInfoParam)).subscribe(state => {
            this.cCentricInfo = state.SatMotorState.cCentricInfo;
            this.loadCCentricDetails();
            if (this.cCentricInfo.contractId || this.cCentricInfo.cnoteType) {
              if(!this.ccManualClickSatMenu) {
              this.performSearchQuotation(true);
              }
            }else {
	      let cCentricVehicleNo = this.cCentricInfo?.vehicleNo ?? this.cCentricInfo?.cngeNoteDto?.vehicleNo;
              this.store.dispatch(new CCENTRIC_VEH_NOT_FOUND_POPULATE_DATA(this.cCentricInfo));
              if (cCentricVehicleNo && cCentricVehicleNo !== "NA") {
                if(!this.ccManualClickSatMenu) {
                this.performSearchQuotation(true);
                }
              }
            }
            this.store.dispatch(new SET_CCENTRIC_ISSUANCE_IND(true));
          });
        }
      }
    }

    if (this.isRenewal) {
      this.issuanceForm.controls["effectiveDate"].disable({ emitEvent: false });

      const isCoverageStepExist: boolean = !!this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3);
      const isCpExtracted: boolean = !!this.store.selectSnapshot<any>(state => {
        const cpType = state.SatMotorState?.data?.step2?.cpType;
        return cpType && cpType !== 'NOT_FOUND';
      });

      if (isCoverageStepExist || isCpExtracted) {
        const fieldsToDisable = ['cnoteType', 'vehicleNo', 'idType', 'idNumberText', 'productCode'];

        fieldsToDisable.forEach(field => {
          const control = this.issuanceForm.controls[field];
          if (control?.value) {
            control.disable({ emitEvent: false });
          }
        });
      }
    }

    if (this.isEndorsement) {
      this.isEndtLoading = false;
    }

  }

  updateProductDesc(code: any) {
    try {
      if (code === null || code === undefined) {
        console.log('Product code is null');
        this.store.dispatch(new SET_PRODUCT_CODE_DESCRIPTION({ descp: null }));
        return;
      }

      const product = this.productList.find(item => item.code === code);

      if (!product) {
        console.log('Product not found');
        this.store.dispatch(new SET_PRODUCT_CODE_DESCRIPTION({ descp: null }));
        return;
      }

      const productDescp = product.descp ? product.descp : null;
      this.store.dispatch(new SET_PRODUCT_CODE_DESCRIPTION({ descp: productDescp }));
    } catch (error) {
      console.log('Error updating product description:', error.message);
      this.store.dispatch(new SET_PRODUCT_CODE_DESCRIPTION({ descp: null }));
    }
  }

  loadPreviousPolicyDetails() {
    this.previousPolicyNo = this.previousPolicyDetails.previousPolicyNo;
    this.issuanceForm.patchValue({
      vehicleNo: this.previousPolicyDetails.vehicleNo,
      productCode: this.previousPolicyDetails.productCode,
      prevPolicyNo: this.previousPolicyDetails.previousPolicyNo,
      //effectiveDate: this.previousPolicyDetails.effectiveDate,
      //expiryDate: this.previousPolicyDetails.expiryDate,
      idNumberText: this.previousPolicyDetails.clientPartner.idValue1
    });
    this.isVehicleIdNoExist = true;
    this.isRNSearchComplete = true;
    this.isSecondSearchComplete = true;

    const fieldsToDisable = [
      'cnoteType',
      'vehicleNo',
      'idType',
      'idNumberText',
      'productCode'
    ];

    if (this.isRenewal) {
      fieldsToDisable.push('effectiveDate');
    } else {
      this.issuanceForm.controls["effectiveDate"].enable({ emitEvent: false });
    }

    this.disableFields(fieldsToDisable);
  }

  loadCCentricDetails() {
    if(this.cCentricInfo){
      const today = new Date();
      const localDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
      this.isVehicleIdNoExist = true;
      this.isRNSearchComplete = true;
      this.isSecondSearchComplete = true;

      let vehicleNo = this.cCentricInfo.vehicleNo;

      let idType = this.cCentricInfo?.cngeNoteDto?.clientPartner?.idType1 ?? this.cCentricInfo?.clientPartner?.idType1;
      let idValue = this.cCentricInfo?.cngeNoteDto?.clientPartner?.idValue1 ?? this.cCentricInfo?.clientPartner?.idValue1;
  
      this.issuanceForm.patchValue({
        vehicleNo: vehicleNo?.toUpperCase(),
        idType: this.cCentricInfo?.cngeNoteDto?.clientPartner?.idType1 ?? this.cCentricInfo?.clientPartner?.idType1,
        idNumberText: this.cCentricInfo?.cngeNoteDto?.clientPartner?.idValue1 ?? this.cCentricInfo?.clientPartner?.idValue1,
        effectiveDate: localDate,
        productCode: this.cCentricInfo.productCode? this.cCentricInfo.productCode :''
      });

      if (!vehicleNo || vehicleNo == "NA") {
        this.issuanceForm.controls['cnoteType'].setValue('NWNN');
      }

      if(idType && idValue && idType === 'NRIC') {
        this.custAge = this.getCalculateAge(idValue);
      }
    }
    
  }

  loadRTP() {
    this.coverNoteTypeList = [
      {
        "code": "RTP",
        "descp": "ROAD TAX PURPOSE"
      }
    ];

    this.issuanceForm = new FormGroup({
      cnoteType: new FormControl({ value: '', disabled: true }),
      vehicleNo: new FormControl('', [
        Validators.required, Validators.pattern('^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d-]{1,20}$')
      ]),
      prevPolicyNo: new FormControl({ value: '', disabled: true }),
      productCode: new FormControl({ value: '', disabled: true }),
      specialVehicleInd: new FormControl({ value: false, disabled: true }),
      effectiveDate: new FormControl({ value: '', disabled: true }),
      expiryDate: new FormControl({ value: '', disabled: true })
    });

    this.issuanceForm.controls['cnoteType'].setValue('RTP');
    this.loadIssuanceData();
  }

  loadEndorsement() {
    this.issuanceForm = new FormGroup({
      vehicleNo: new FormControl('', [
        Validators.required, Validators.pattern('^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d-]{1,20}$')
      ]),
      policyNo: new FormControl({ value: '', disabled: true }),
      productCode: new FormControl({ value: '', disabled: true }),
      policyEffectiveDate: new FormControl({ value: '', disabled: true }),
      policyExpiryDate: new FormControl({ value: '', disabled: true }),
      endorsementType: new FormControl('', Validators.required),
      endtEffectiveDate: new FormControl(''),
      endtExpiryDate: new FormControl(''),
      previousExtension: new FormControl('')
    });

    this.updateEndtWatcher();
    this.getLov();
    this.loadAgentData();
    this.loadEndorsementData();
  }

  loadIssuance() {
    this.issuanceForm = new FormGroup({
      cnoteType: new FormControl('', Validators.required),
      vehicleNo: new FormControl('', [
        Validators.required, Validators.pattern('^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d-]{1,20}$')
      ]),
      idType: new FormControl('', Validators.required),
      idNumberText: new FormControl('', Validators.required),
      prevPolicyNo: new FormControl(''),
      productCode: new FormControl('', Validators.required),
      specialVehicleInd: new FormControl(false),
      effectiveDate: new FormControl('', Validators.required),
      expiryDate: new FormControl('', [
        Validators.required,
        this.expiryDateValidator()
      ])
    });

    this.issuanceForm.controls["effectiveDate"].enable({ emitEvent: false });
    this.issuanceForm.controls['effectiveDate'].updateValueAndValidity({ emitEvent: false });

    this.updateWatcher();
    this.getLov();
    this.loadAgentData();
    if(!this.isCpStepExist) {
      this.loadQueryParamData();
    }
    this.loadIssuanceData();

    if (!this.issuanceForm.controls['cnoteType'].value || this.issuanceForm.controls['cnoteType'].value.trim() === '') {
      this.issuanceForm.controls['cnoteType'].setValue('NWOO/RN');
      this.issuanceForm.controls['idType'].setValue('NRIC');
    }

    let isCoverageStepExist: boolean = !!this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3);
    let isCpExtracted: boolean = !!this.store.selectSnapshot<any>(state => {
      const cpType = state.SatMotorState?.data?.step2?.cpType;
      return cpType && cpType !== 'NOT_FOUND';
    });

    if (isCoverageStepExist || isCpExtracted) {
      if (this.verifyCnoteType() === 'NWOO') {
        const fieldsToDisable = ['cnoteType', 'vehicleNo', 'idType', 'idNumberText', 'productCode'];
        fieldsToDisable.forEach(field => this.issuanceForm.controls[field].disable());

        this.isVehicleIdNoExist = true;
        this.isRNSearchComplete = true;
        this.isSecondSearchComplete = true;
        const { idNumberText, productCode, effectiveDate, expiryDate } = this.issuanceStateData;
        this.issuanceForm.patchValue({ idNumberText, productCode, effectiveDate, expiryDate });
      }

      if (this.verifyCnoteType() === 'NWNN') {
        const fieldsToDisable = ['cnoteType', 'productCode'];
        fieldsToDisable.forEach(field => this.issuanceForm.controls[field].disable());

        this.isVehicleIdNoExist = true;
        const { productCode } = this.issuanceStateData;
        this.issuanceForm.patchValue({ productCode });
      }

      if (this.verifyCnoteType() === 'NWTR') {
        const fieldsToDisable = ['cnoteType', 'productCode'];
        fieldsToDisable.forEach(field => this.issuanceForm.controls[field].disable());

        this.isVehicleIdNoExist = true;
        const { productCode, effectiveDate, expiryDate } = this.issuanceStateData;
        this.issuanceForm.patchValue({ productCode, effectiveDate, expiryDate });
      }

      if (this.statePDPAData) {
        this.pdpaForm.patchValue(this.statePDPAData);
      }
    }
  }

  loadEndorsementData() {
    this.endtIssuanceData$.subscribe((state) => {
      if (state) {
        if (state.issuance) {
          const { endtEffectiveDate, endtExpiryDate, ...rest } = state.issuance;
          this.issuanceForm.patchValue(rest);

          this.issuanceForm.controls['endtEffectiveDate'].setValue(endtEffectiveDate, { emitEvent: false });
          this.issuanceForm.controls['endtExpiryDate'].setValue(endtExpiryDate, { emitEvent: false });

          this.endtIssuanceData = state.issuance;
          this.defaultEndtEffectiveDate = this.endtIssuanceData.defaultEndtEffectiveDate;
          this.defaultEndtExpiryDate = this.endtIssuanceData.defaultEndtExpiryDate;
        }
        this.issuanceForm.controls['vehicleNo'].disable();
        this.issuanceForm.controls['endorsementType'].disable();

        if (state.pdpa) {
          this.pdpaForm.patchValue(state.pdpa);
        }
      }
    });

    this.endtVehicleData$.subscribe((state) => {
      this.endtVehicleFound = !!state && !!this.endorsementList;
      this.endtPolicy = state || {};

      if (!state) {
        const previousExtensionControl = this.issuanceForm.get('previousExtension');
        previousExtensionControl.clearValidators();
        previousExtensionControl.updateValueAndValidity();
        this.previousExtension = false;

        this.issuanceForm.reset({
          vehicleNo: '',
          policyNo: '',
          productCode: '',
          policyEffectiveDate: '',
          policyExpiryDate: '',
          endorsementType: '',
          endtEffectiveDate: '',
          endtExpiryDate: '',
          previousExtension: ''
        });
      }

      if (state && this.endtPolicy) {
        this.productList = [
          {
            code: this.endtPolicy.productCode,
            descp: this.endtPolicy.productName
          }
        ];

        this.endtPreviousPolicy = this.store.selectSnapshot(SatMotorState.endtPreviousVehiclePolicy);

        if(this.endorsementList && this.endtIssuanceData && this.endtIssuanceData?.endorsementType) {
          this.updateEndtDateState(this.endtIssuanceData?.endorsementType);
        }
      }

      this.pdpaForm.get('consentDetails.einvoiceConsentInd').disable();
    });

  }

  populateEndtFormData(issuanceData) {
    this.issuanceForm.setValue({
      vehicleNo: this.endtPolicy?.riskList[0]?.vehicleNo || '',
      policyNo: this.endtPolicy?.policyNo || '',
      productCode: this.endtPolicy?.productCode || '',
      policyEffectiveDate: this.endtPolicy?.effectiveDate || '',
      policyExpiryDate: this.endtPolicy?.expiryDate || '',
      endorsementType: issuanceData?.endorsementType || '',
      endtEffectiveDate: issuanceData?.endtEffectiveDate || '',
      endtExpiryDate: issuanceData?.endtExpiryDate || '',
      previousExtension: issuanceData?.previousExtension || ''
    });

    if (issuanceData?.endorsementType === 'ENDT04') {
      const previousExtensionControl = this.issuanceForm.get('previousExtension');
      this.previousExtension = true;
      previousExtensionControl.setValidators([Validators.required]);
      previousExtensionControl.updateValueAndValidity();
    }

    if (issuanceData && issuanceData?.endorsementType === 'EC176') {
      this.pdpaForm.get('consentDetails.einvoiceConsentInd').setValue(true);
    
    } else if (typeof this.endtPolicy?.einvoiceConsentInd === 'boolean') {
      this.pdpaForm.get('consentDetails.einvoiceConsentInd').setValue(this.endtPolicy.einvoiceConsentInd);
    }

    this.issuanceForm.controls['vehicleNo'].disable();
    if (issuanceData?.endorsementType) {
    }

    if(issuanceData?.endorsementType) {
      this.updateEndtDateState(issuanceData?.endorsementType);
    }

    Object.keys(this.issuanceForm.controls).forEach(key => {
      this.issuanceForm.controls[key].setErrors(null);
      this.issuanceForm.controls[key].markAsPristine();
      this.issuanceForm.controls[key].markAsUntouched();
      this.issuanceForm.controls[key].updateValueAndValidity();
    });
  }

  onEndorsementTypeChange(event: any): void {
    let previousExtensionControl = this.issuanceForm.get('previousExtension');
    let endtEffectiveDateControl = this.issuanceForm.get('endtEffectiveDate');
    let endtExpiryDateControl = this.issuanceForm.get('endtExpiryDate');

    if (event.value === 'ENDT04') {
      previousExtensionControl.setValidators([Validators.required]);
      this.previousExtension = true;
    } else {
      previousExtensionControl.clearValidators();
      previousExtensionControl.setValue(null);
      previousExtensionControl.setErrors(null);
      previousExtensionControl.markAsPristine();
      previousExtensionControl.markAsUntouched();
      this.previousExtension = false;
    }
    previousExtensionControl.updateValueAndValidity();

    if (event.value && event.value !== '') {
      this.updateEndtDateValidations(event.value);
    }

    [endtEffectiveDateControl, endtExpiryDateControl].forEach(control => {
      if (event.value != 'XP') {
        control.setValidators([Validators.required]);
      } else {
        control.clearValidators();
      }

      if (control.value === null || control.value === undefined) {
        this.resetFields(['endtExpiryDate']);
      } else {
        control.updateValueAndValidity();
      }
      
    });    

    this.validateEndorsementType(event.value, this.endtPolicy, this.endtPreviousPolicy);
    this.store.dispatch(new UPDATE_ENDORSEMENT_STEP2({isReset: true}));
  }

  validateEndorsementType(endtType, data, htgePolData) {
    let riskList = data.riskList[0];
    let coverList = riskList.coverList[0];

    let cnoteType = '';
    let endtCode = '';
  
    if (endtType === 'COE' || endtType === 'XP') {
      cnoteType = endtType;
      endtCode = endtType;
    } else if (endtType.startsWith('ENDT')) {
      cnoteType = endtType;
      endtCode = endtType.substring(4);
    } else if (endtType.startsWith('EC')) {
      cnoteType = endtType;
      endtCode = endtType.substring(2);
    }

    let payload = {
      vehicleNo: riskList.vehicleNo,
      cngeNoteDto: {
        cnoteType: cnoteType,
        cnoteDate: data.cnoteDate,
        endtCode: endtCode,
        policyNo: data.policyNo,
        productCode: data.productCode,
        einvoiceConsentInd: data.einvoiceConsentInd,
        mkagAgent: {
          agentCode: data.mkagAgent.agentCode
        },
        riskList: [
          {
            vehicleModel: riskList.vehicleModel,
            vehModelNvic: riskList.vehModelNvic,
            coverList: [
              {
                coverCode: coverList.coverCode
              }
            ]
          }
        ]
      },
      htgePol: {
        ncdPercentage: htgePolData?.ncdPercentage ?? 0,
        einvoiceStatus: htgePolData?.einvoiceStatus,
        ...htgePolData
      }
    };
    
    this.store.dispatch(new ENDORSEMENT_TYPE_VALIDATION(payload)).subscribe((res) => {
      let response = (res && res.SatMotorState?.endorsement?.step1?.endtTypeResponse) ?? null;

      if (endtType && endtType === 'XP' && response && response.data) {
        let avInd = response.data?.riskList[0]?.avInd;
        let avCode = response.data?.riskList[0]?.avCode || null;
        let nvicNo = response.data?.riskList[0]?.nvicNo || null;

        this.store.dispatch(new UPDATE_ENDT_XP_VALIDATION({avInd, avCode, nvicNo}));
      }

      if (response && response.success) {
        if (response.message && response.message != '') {
          if (endtType && endtType === 'XP')
            this.showOkMessage(response.message);
        }
      } else {
        this.resetInvalidatedFields(['endorsementType', 'endtEffectiveDate', 'endtExpiryDate']);
        if (response.message && response.message != '') {
          this.showOkMessage(response.message);
        }
      }

      //AGIC-50219
      const consentControl = this.pdpaForm.get('consentDetails.einvoiceConsentInd');
      const einvoiceConsentInd = this.endtPolicy?.einvoiceConsentInd;

      if (endtType === 'EC176' && response?.success) {
        consentControl?.setValue(true);
      } else if (typeof einvoiceConsentInd === 'boolean' && response?.success) {
        consentControl?.setValue(einvoiceConsentInd);
      } else {
        consentControl?.setValue(typeof einvoiceConsentInd === 'boolean' ? einvoiceConsentInd : null);
      }

    });
  }
  

  resetInvalidatedFields(fieldList: string[]) {
    fieldList.forEach(field => {
      if (this.issuanceForm.controls[field]) {
        this.issuanceForm.controls[field].clearValidators();
        this.issuanceForm.controls[field].setValue(null);
        this.issuanceForm.controls[field].setErrors(null);
        this.issuanceForm.controls[field].markAsPristine();
        this.issuanceForm.controls[field].markAsUntouched();
        this.issuanceForm.controls[field].updateValueAndValidity();
      }
    });
    this.issuanceForm.updateValueAndValidity();
  }

  updateEndtDateState(type: string): void {
    const typesForSetFieldStateTrueFalse = [
      'COE', 'ENDT05', 'ENDT09', 'ENDT10', 'ENDT12', 'ENDT17', 'ENDT18',
      'ENDT22', 'ENDT23', 'ENDT24', 'ENDT25', 'ENDT30', 'ENDT34', 'ENDT29'
    ];

    if (type === 'XP' || type === 'XS') {
      this.setFieldState(false, true);

    } else if (type === 'ENDT04') {
      this.setFieldState(true, true);

    } else if (type === 'EC175' || type === 'EC176') {
      this.setFieldState(false, false);

    } else if (typesForSetFieldStateTrueFalse.includes(type)) {
      this.setFieldState(true, false);
      if (type === 'ENDT17') {
        const selectedExtraCoverList = this.store.selectSnapshot<any>(
          state => state.SatMotorState?.endorsement?.step3?.coverage?.extracover?.extraCoverPackageSummary?.selectedExtraCoverList
        );

        const findThailandExtraCoverage = selectedExtraCoverList?.some(obj => (obj.subCoverCode === '101' || obj.subCoverCode === '102' || obj.subCoverCode === '101(a)') && obj.subCoverPrem > 0);
        if (findThailandExtraCoverage) {
          this.setFieldState(true, true);
        }
      }
    } else {
      // do nothing
    }
  }

  updateEndtDateValidations(type: string) {
    console.log("Type: " + type);
    this.issuanceForm.get('endtEffectiveDate').setValue(null, { emitEvent: false });
    this.issuanceForm.get('endtExpiryDate').setValue(null, { emitEvent: false });
    const policyEffDate = new Date(this.issuanceForm.get('policyEffectiveDate').value);
    const policyExpDate = new Date(this.issuanceForm.get('policyExpiryDate').value);
    const currentDate = new Date();

    switch (type) {
      case 'COE':
        this.updateEndorsementDates(policyEffDate <= currentDate ? currentDate : policyEffDate, policyExpDate);
        this.setFieldState(true, false);
        break;
      case 'XP':
      case 'XS':
        const nextDay = new Date(policyExpDate);
        nextDay.setDate(policyExpDate.getDate() + 1);
        this.updateEndorsementDates(nextDay, null);
        this.setFieldState(false, true);
        break;
      case 'ENDT04':
        this.updateEndorsementDates(policyEffDate, policyExpDate);
        this.setFieldState(true, true);
        break;
      case 'EC175':
      case 'EC176':
        this.updateEndorsementDates(policyEffDate, policyExpDate);
        this.setFieldState(false, false);
        break;
      case 'ENDT05':
      case 'ENDT09':
      case 'ENDT10':
      case 'ENDT12':
      case 'ENDT17':
      case 'ENDT18':
      case 'ENDT22':
      case 'ENDT23':
      case 'ENDT24':
      case 'ENDT25':
      case 'ENDT30':
      case 'ENDT34':
      case 'ENDT29':
        this.updateEndorsementDates(policyEffDate <= currentDate ? currentDate : policyEffDate, policyExpDate);
        this.setFieldState(true, false);
        break;
      default:
        break;
    }
  }

  updateEndorsementDates(effectiveDate: Date | null, expiryDate: Date | null) {
    this.issuanceForm.get('endtEffectiveDate').setValue(effectiveDate, { emitEvent: false });
    this.issuanceForm.get('endtExpiryDate').setValue(expiryDate, { emitEvent: false });
    this.defaultEndtEffectiveDate = effectiveDate;
    this.defaultEndtExpiryDate = expiryDate;
  }

  setFieldState(effDtCtrl: boolean, expDtCtrl: boolean) {
    this.setControlState('endtEffectiveDate', effDtCtrl);
    this.setControlState('endtExpiryDate', expDtCtrl);
  }

  setControlState(controlName: string, enable: boolean) {
    const control = this.issuanceForm.get(controlName);
    if (control) {
      enable ? control.enable() : control.disable();
    }
  }

  loadIssuanceData() {
    if (this.isIssuance) {
      this.issuanceData$.subscribe((state) => {
        if (state && !this.nextButtonClicked) {
          if (state.issuance) {
            this.issuanceStateData = state.issuance;
            let updatedIssuance = { ...state.issuance };
            if(updatedIssuance.cnoteType === 'RN') {
              this.isRenewal = true;
            }
            if (updatedIssuance.prevPolicyNo) { //NWOO case also can have previous policy
              this.previousPolicyNo = updatedIssuance.prevPolicyNo;
            }

            if (updatedIssuance.cnoteType === 'NWOO' || updatedIssuance.cnoteType === 'RN') {
              updatedIssuance.cnoteType = 'NWOO/RN';
            }

            this.updateProductList(updatedIssuance.idType);

            if (updatedIssuance.cnoteType !== 'NWOO/RN' && updatedIssuance.idType === ''){ //re-assign Product list LOV for NWNN/NWTR.
              this.filteredProductList = this.productList;
            }

            this.issuanceForm.patchValue(updatedIssuance, { emitEvent: false });

            if ((updatedIssuance.cnoteType === 'NWNN' || updatedIssuance.cnoteType === 'NWTR') && this.productList) {
              this.filteredProductList = this.productList;
            }

            if (updatedIssuance && (updatedIssuance.idType === 'NEW_BR_NO' || updatedIssuance.idType === 'BR_NO')) {
              this.checkInvoiceConsentInd(updatedIssuance.idType);
            }
            this.updateIdNumberTextValidator(updatedIssuance.idType, false);
            this.isVehicleIdNoExist = true;
            this.isRNSearchComplete = true;
            this.isSecondSearchComplete = true;
          }
          if (state.pdpa) {
            this.statePDPAData = state.pdpa;
            this.pdpaForm.patchValue(state.pdpa);
            
            if(this.clientDetails){
              
              if(this.clientDetails?.clientType === 'I'){
                if (this.lovproductConfig){
                  this.lovproductConfig.map(item => {
                    if (Object.keys(item)[0] === this.issuanceInfo.productCode){
                      this.eInvoiceEnableInd(item[Object.keys(item)[0]].einvoiceEnabled);
                    }
                  });
                }
              }
            }
          }
        }
      });
    }

    if (this.isRTP) {
      const rtpPolicy = this.store.selectSnapshot<any>(state => state.SatMotorState?.rtp?.step1?.rtpPolicy);
      this.isRTPDataExist = rtpPolicy ? true : false;
      if (rtpPolicy) {
        this.filteredProductList = [
          {
            code: rtpPolicy?.data?.cngeNoteDto?.productCode,
            descp: rtpPolicy?.data?.cngeNoteDto?.productName
          }
        ];
        this.populateRTPForm(rtpPolicy?.data?.cngeNoteDto);
        this.pdpaForm.get('pdpaCheck')?.setValue(true);
      }
    }
  }

  loadAgentData() {
    this.agentDetail$.subscribe((state) => {
      if (state) {
        this.agentData = state;
      }
    });
  }

  loadQueryParamData() {
    if (this.queryParams) {
      if (this.queryParams.vehicleNo) {
        this.issuanceForm.controls['vehicleNo'].setValue(this.queryParams.vehicleNo);
      }

      if (this.queryParams.cnoteType) {
        this.issuanceForm.controls['cnoteType'].setValue(this.queryParams.cnoteType);
      }

      if (this.queryParams.idType) {
        this.issuanceForm.controls['idType'].setValue(this.queryParams.idType);
        this.isCMRedirection = true;
      }

      if (this.queryParams.idValue) {
        this.issuanceForm.controls['idNumberText'].setValue(this.queryParams.idValue);
      }

      if (this.queryParams.prevPolicyNo) {
        this.issuanceForm.controls['prevPolicyNo'].setValue(this.queryParams.prevPolicyNo);
      }

      if (this.queryParams.productCode) {
        this.issuanceForm.controls['productCode'].setValue(this.queryParams.productCode);
      }

      if ((!this.queryParams.cnoteType || !this.queryParams.productCode) && this.queryParams.idType && this.queryParams.idValue) {
        this.updateCurrentDate();
      }

      if(this.queryParams.idType && this.queryParams.idValue && this.queryParams.idType === 'NRIC') {
        this.custAge = this.getCalculateAge(this.queryParams.idValue);
      }
      
    }
  }

  updateCurrentDate() {
    const effectiveDateControl = this.issuanceForm.get('effectiveDate');
    const expiryDateControl = this.issuanceForm.get('expiryDate');

    const currentDate = new Date();
    const nextYearDate = new Date(currentDate);
    nextYearDate.setFullYear(currentDate.getFullYear() + 1);
    nextYearDate.setFullYear(currentDate.getFullYear() + 1) && nextYearDate.setDate(nextYearDate.getDate() - 1);

    const formattedEffectiveDate = currentDate.toISOString().substring(0, 10);
    const formattedExpiryDate = nextYearDate.toISOString().substring(0, 10);

    effectiveDateControl.setValue(formattedEffectiveDate);
    expiryDateControl.setValue(formattedExpiryDate);
  }

  updateEndtWatcher() {
    this.issuanceForm.get('endtEffectiveDate').valueChanges.subscribe(value => {
      if (this.nextButtonClicked || this.isEndtLoading) {
        return;
      }
      this.showEndtDateValidateError = false;
      this.dateValidateError = '';
      let isEffDateError: boolean = false;
      let endorsementType = this.issuanceForm.controls['endorsementType'].value;

      if (value) {
        let endtExpiryDate = this.issuanceForm.controls['endtExpiryDate'].value;
        let policyEffectiveDate = this.issuanceForm.controls['policyEffectiveDate'].value;
        const endtEffectiveDate = moment(new Date(value));
        const currentDate = moment();

        if (!this.showEndtDateValidateError && policyEffectiveDate && policyEffectiveDate != '') {
          const effectiveDate = moment(new Date(policyEffectiveDate));

          if (endtEffectiveDate.isBefore(effectiveDate, 'day')) {
            isEffDateError = true;
            this.showEndtDateValidateError = true;
            this.issuanceForm.get('endtEffectiveDate')?.setValue(this.defaultEndtEffectiveDate, { emitEvent: false });
            this.showEndtOkMessage(`Endorsement Effective date cannot be before the effective date of the policy (${effectiveDate.format('DD/MM/YYYY')}).`);   
          }
        }

        if (endorsementType && endorsementType != 'ENDT04' && endorsementType != 'EC175' && endorsementType != 'EC176') {
          if (!this.showEndtDateValidateError && endtEffectiveDate.isBefore(currentDate, 'day')) {
            this.showEndtDateValidateError = true;
            this.issuanceForm.get('endtEffectiveDate')?.setValue(this.defaultEndtEffectiveDate, { emitEvent: false });
            this.showEndtOkMessage('Endorsement Effective date cannot be earlier than issued date.');
          }
        }

        if (!this.showEndtDateValidateError && endtExpiryDate && endtExpiryDate != '') {
          const expiryDate = moment(new Date(endtExpiryDate));

          if (endtEffectiveDate.isAfter(expiryDate, 'day')) {
            isEffDateError = true;
            this.showEndtDateValidateError = true;
            this.issuanceForm.get('endtEffectiveDate')?.setValue(this.defaultEndtEffectiveDate, { emitEvent: false });
            this.showEndtOkMessage('Endorsement Effective date cannot be after expiry date.');
          }
        }

        if (endorsementType && endorsementType === 'ENDT04' && !isEffDateError) { //AGIC-46667
          const updatedEndtEffectiveDate = moment(new Date(value)).add(1, 'year').subtract(1, 'day');
          this.issuanceForm.get('endtExpiryDate')?.setValue(updatedEndtEffectiveDate, { emitEvent: false });
        }
      }
    });

    this.issuanceForm.get('endtExpiryDate').valueChanges.subscribe(value => {
      if (this.nextButtonClicked || this.isEndtLoading) {
        return;
      }
      this.showEndtDateValidateError = false;
      this.dateValidateError = '';
      let endorsementType = this.issuanceForm.controls['endorsementType'].value;

      if (value) {
        let endtEffectiveDate = this.issuanceForm.controls['endtEffectiveDate'].value;
        let endtExpiryDate = this.issuanceForm.controls['endtExpiryDate'].value;
        let policyEffectiveDate = this.issuanceForm.controls['policyEffectiveDate'].value;
        const currentDate = moment();

        if (endorsementType && endorsementType == 'ENDT04') {
          if (policyEffectiveDate && policyEffectiveDate != '') {
            const policyEffDate = moment(new Date(policyEffectiveDate));
            const endtEffDate = moment(new Date(endtEffectiveDate));
  
            if (endtEffDate.isBefore(policyEffDate, 'day')) {
              this.issuanceForm.get('endtEffectiveDate')?.setValue(policyEffectiveDate, { emitEvent: false });
              endtEffectiveDate = policyEffectiveDate;
            }
          }
        }

        if (endorsementType && endorsementType == 'XP') {
          const effectiveDate = moment(new Date(endtEffectiveDate));
          const expiryDate = moment(new Date(endtExpiryDate));

          if (expiryDate.diff(effectiveDate, 'months', true) > 6) {
            this.showEndtDateValidateError = true;
            this.issuanceForm.get('endtExpiryDate')?.setValue(this.defaultEndtExpiryDate, { emitEvent: false });
            this.showEndtOkMessage('Expiry date cannot be more than 6 months after effective date.');
          }
        }

        if (!this.showEndtDateValidateError && endtExpiryDate && endtEffectiveDate) {
          const effectiveDate = moment(new Date(endtEffectiveDate));
          const expiryDate = moment(new Date(endtExpiryDate));

          if (expiryDate.isBefore(effectiveDate, 'day') || expiryDate.isSame(effectiveDate, 'day')) {
            this.showEndtDateValidateError = true;
            this.issuanceForm.get('endtExpiryDate')?.setValue(this.defaultEndtExpiryDate, { emitEvent: false });
            this.showEndtOkMessage('Expiry date cannot be earlier than effective date.');
          }
        }
      } else {
        if (endorsementType && endorsementType == 'XP') {
          this.issuanceForm.controls['endtExpiryDate'].setValidators([Validators.required]);
          this.issuanceForm.controls['endtExpiryDate'].updateValueAndValidity({ emitEvent: false });
        }
      }

    });
  }

  updateWatcher() {
    this.issuanceForm.get('cnoteType').valueChanges.subscribe(value => {
      this.updateValidatorBasedCNoteType(value);
      if (value === 'NWNN') {
        this.issuanceForm.get('vehicleNo').setValue('NA');
      }
      this.isEffectiveDateValidation = false;
    });

    this.issuanceForm.get('idType').valueChanges.subscribe(value => {
      this.updateIdNumberTextValidator(value, true);
      this.updateProductList(value);
      this.checkInvoiceConsentInd(value);
    });

    this.issuanceForm.get('effectiveDate').valueChanges.subscribe(value => {
      if (value && value !== 'NA') {
        if(this.verifyCnoteType() !== 'NWNN' && this.previousPolicyDetails?.cnoteType !== 'RN'
        && !this.activeQuotationDetails) {
          this.isEffectiveDateValidation = true;
        }
        const effectiveDate = moment(new Date(value));
        let effectiveDateVal = this.issuanceForm.controls['effectiveDate'].value;
        if (effectiveDateVal && effectiveDateVal !== 'NA') {
          const expiryDate = effectiveDate.clone().add(1, 'year').subtract(1, 'day');
          this.issuanceForm.controls['expiryDate'].setValue(expiryDate);
        }
      }
    });

    this.issuanceForm.get('expiryDate').valueChanges
      .pipe(
        debounceTime(1000),
        distinctUntilChanged()
      )
      .subscribe(value => {
        const formData = this.issuanceForm.getRawValue();

        if (formData.productCode && formData.productCode.trim() !== '' && value 
          && value !== 'NA' && formData.effectiveDate) {

          const expiryDate = moment(new Date(value));
          this.validateExpiryDateFormat();
          if (
            expiryDate.isValid() &&
            !this.issuanceForm.controls['effectiveDate'].errors &&
            !this.issuanceForm.controls['expiryDate'].errors
          ) {
            this.validateDate();
          }
        }
    });

    if (!this.issuanceForm.controls['cnoteType'].value || this.issuanceForm.controls['cnoteType'].value.trim() === '') {
      this.issuanceForm.controls['cnoteType'].setValue('NWOO/RN');
      this.issuanceForm.controls['idType'].setValue('NRIC');
    }

    this.issuanceForm.get('productCode').valueChanges.subscribe(value => {
      if(this.issuanceForm?.controls['idType']?.value === "NEW_BR_NO" || this.issuanceForm?.controls['idType']?.value === "BR_NO" || this.clientDetails?.clientType === 'I'){ //AGIC-45992
        if (this.lovproductConfig){
          let proCode = value === "" ? Object.keys(this.lovproductConfig[0])[0] : value;
          this.lovproductConfig.map(item => {
            if(Object.keys(item)[0] === proCode) {
              this.isEinvoiceEnabled = item[Object.keys(item)[0]]?.einvoiceEnabled;
            }
          });
        this.eInvoiceEnableInd(this.isEinvoiceEnabled);
        }
      } else {
        this.eInvoiceEnableInd(true);
      }
    });

  }

  validateExpiryDateFormat() {
    const expiryDateValue = this.issuanceForm.get('expiryDate').value;

    if (moment.isMoment(expiryDateValue)) {
      if (expiryDateValue.isValid()) {
        const formattedDate = expiryDateValue.format('YYYY-MM-DD');
        console.log(formattedDate);
        this.issuanceForm.get('expiryDate').setValue(formattedDate, { emitEvent: false });
      } else {
        console.log('Invalid date');
      }
    } else {
      if (moment(expiryDateValue).isValid()) {
        const formattedDate = moment(expiryDateValue).format('YYYY-MM-DD');
        console.log(formattedDate);
        this.issuanceForm.get('expiryDate').setValue(formattedDate, { emitEvent: false });
      } else {
        console.log('Invalid date');
      }
    }
  }

  checkInvoiceConsentInd(value: any) {
    const einvoiceConsentControl = this.pdpaForm.get('consentDetails.einvoiceConsentInd');
    let cnoteType = this.issuanceForm.controls['cnoteType'].value ?? null;

    if (cnoteType === 'NWNN' || cnoteType === 'NWTR' || (cnoteType === 'NWOO/RN' && (value === 'NRIC' || value === 'OLD_IC' || value === 'PASS' || value === 'POL'))) {
      if (einvoiceConsentControl.disabled && !this.clientDetails) {
        einvoiceConsentControl.enable();
        einvoiceConsentControl.setValue(null);
      }
    } else {
      if (value === 'NEW_BR_NO' || value === 'BR_NO') {
        let firstproductConfig: boolean[] = [false];
        if (this.lovproductConfig){
          firstproductConfig = this.lovproductConfig.map(item => {
            const key = Object.keys(item)[0]; // Get first product key.(dynamic)
            return item[key].einvoiceEnabled;  // Return first product einvoiceEnabled indicator.
          });
        }

        if(firstproductConfig[0]){
          this.eInvoiceEnableInd(firstproductConfig)
        } else {
          einvoiceConsentControl.setValue(true);
          einvoiceConsentControl.disable();
        }
      } else {
        einvoiceConsentControl.setValue(null);
        einvoiceConsentControl.enable();
      }
    }
  }

  updateProductList(value: any) {
    if (value) {
      const productCodes = this.idTypeProductMap[value] || [];
      this.filteredProductList = this.productList.filter(product => productCodes.includes(product.code));
    }
  }

  updateValidatorBasedCNoteType(cnoteType: string) {
    const vehicleNoControl = this.issuanceForm.get('vehicleNo');
    const idTypeControl = this.issuanceForm.get('idType');
    const productCodeControl = this.issuanceForm.get('productCode');
    const idNumberTextControl = this.issuanceForm.get('idNumberText');
    const effectiveDateControl = this.issuanceForm.get('effectiveDate');
    const expiryDateControl = this.issuanceForm.get('expiryDate');

    if (cnoteType === 'NWOO/RN') {
      vehicleNoControl.setValidators([
        Validators.required, Validators.pattern('^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d-]{1,20}$')
      ]);
      idTypeControl.setValidators(Validators.required);
      idNumberTextControl.setValidators(Validators.required);
      this.isVehicleIdNoExist = false;

      if (!idTypeControl.value) {
        idTypeControl.setValue('NRIC');
      }
    } else {
      this.filteredProductList = this.productList;
      if (this.isCMRedirection && this.queryParams.idType) {
        this.updateProductList(this.queryParams.idType);
      }
      vehicleNoControl.clearValidators();
      idTypeControl.clearValidators();
      idNumberTextControl.clearValidators();

      vehicleNoControl.setErrors(null);
      idTypeControl.setErrors(null, { emitEvent: false });
      idNumberTextControl.setErrors(null, { emitEvent: false });
      this.isVehicleIdNoExist = true;

      productCodeControl.setValue(null, { emitEvent: false });
      productCodeControl.markAsPristine();
      productCodeControl.markAsUntouched(); //AGIC-50190

      idTypeControl.setValue('', { emitEvent: false });
    }


    let effectiveDateVal = this.issuanceForm.controls['effectiveDate'].value;
    let expiryDateVal = this.issuanceForm.controls['expiryDate'].value;

    if (cnoteType === 'NWNN') {
      effectiveDateControl.clearValidators();
      expiryDateControl.clearValidators();

      const currentDate = new Date();
      const nextYearDate = new Date(currentDate);
      nextYearDate.setFullYear(currentDate.getFullYear() + 1);

      const formattedEffectiveDate = currentDate.toISOString().substring(0, 10);
      const formattedExpiryDate = nextYearDate.toISOString().substring(0, 10);

      effectiveDateControl.setValue(formattedEffectiveDate);
      expiryDateControl.setValue(formattedExpiryDate);

    } else {
      effectiveDateControl.setValue(null, { emitEvent: false });
      expiryDateControl.setValue(null, { emitEvent: false }); //AGIC-50190
      effectiveDateControl.setValidators(Validators.required);
      expiryDateControl.setValidators([
        Validators.required, this.expiryDateValidator()
      ]);

      effectiveDateControl.markAsPristine();
      effectiveDateControl.markAsUntouched(); //AGIC-50190
    }

    vehicleNoControl.updateValueAndValidity({ emitEvent: false });
    idTypeControl.updateValueAndValidity({ emitEvent: false });
    idNumberTextControl.updateValueAndValidity({ emitEvent: false });
    effectiveDateControl.updateValueAndValidity({ emitEvent: false });
    expiryDateControl.updateValueAndValidity({ emitEvent: false });
  }

  updateIdNumberTextValidator(idType: string, isReset) {
    const idNumberTextControl = this.issuanceForm.get('idNumberText');
    if (isReset) {
      this.resetFields(['productCode', 'idNumberText', 'effectiveDate', 'expiryDate']);
    }
    let cnoteType = this.issuanceForm.controls['cnoteType'].value;

    if (cnoteType === 'NWOO/RN') {
      if (idType === 'NRIC') {
        idNumberTextControl.setValidators([
          Validators.required,
          this.nricValidator()
        ]);
        this.onlyNumber = true;
      } else if (idType === 'NEW_BR_NO') {
        idNumberTextControl.setValidators([
          Validators.required,
          this.newBrNoValidator()
        ]);
        this.onlyNumber = false;
      } else {
        idNumberTextControl.setValidators([
          Validators.required,
          this.noSpaceValidator(), // Disallow spaces //AGIC-48763
          Validators.maxLength(20)
        ]);
        this.onlyNumber = false;
      }
    } else {
      idNumberTextControl.clearValidators();
    }

    idNumberTextControl.updateValueAndValidity();
  }

  getLov() {
    this.prepareCoverNoteTypeLov(this.lov);
    this.prepareIdTypeLov(this.lov);
  }

  prepareIdTypeLov(lov: any) {
    const filteredList = lov?.clientTypeList.reduce((acc, item) => {
      if (item.code === 'P') {
        item.subList.forEach(sub => {
          let descp = sub.descp;
          if (sub.code === 'NRIC') {
            descp = 'NRIC';
          } else if (sub.code === 'OLD_IC') {
            descp = 'OLD IC NO.';
          } else if (sub.code === 'POL') {
            descp = 'POLICE ID / ARMY ID';
          } else if (sub.code === 'PASS') {
            descp = 'PASSPORT NO.';
          }
          acc.push({ code: sub.code, descp });
        });
      } else if (item.code === 'I') {
        const newBrItem = item.subList.find(sub => sub.code === 'NEW_BR_NO');
        if (newBrItem) acc.push({ code: newBrItem.code, descp: 'NEW BUSINESS REGISTRATION NO.' });

        const brItem = item.subList.find(sub => sub.code === 'BR_NO');
        if (brItem) acc.push({ code: brItem.code, descp: 'BUSINESS REGISTRATION NO.' });
      }
      return acc;
    }, []) || [];

    this.idTypeList = filteredList;

  }

  prepareCoverNoteTypeLov(lov: any) {

    const filteredList = lov?.cnoteTypeList.filter(item =>
      ['NWOO', 'NWNN', 'NWTR', 'RN'].includes(item.code)
    ) || [];

    const sortedList = filteredList.map(item => {
      if (item.code === 'NWOO' || item.code === 'RN') {
        return { code: 'NWOO/RN', descp: 'RENEWAL / NEW BUSINESS - OLD VEHICLE, OLD REGISTRATION' };
      }
      return { ...item, descp: item.descp.toUpperCase() };
    }).filter((item, index, self) =>
      index === self.findIndex((t) => t.code === item.code)
    ).sort((a, b) => {
      const order = ['NWOO/RN', 'NWNN', 'NWTR'];
      return order.indexOf(a.code) - order.indexOf(b.code);
    });

    this.coverNoteTypeList = sortedList;
  }



  getCoverNoteType() {
    let cnoteType = this.issuanceForm.controls['cnoteType'].value;
    return cnoteType ? cnoteType : null;
  }

  isCoverNoteNWOO() {
    return this.getCoverNoteType() === 'NWOO/RN';
  }

  isCoverNoteNWTR() {
    return this.getCoverNoteType() === 'NWTR';
  }

  isCoverNoteNWNN() {
    return this.getCoverNoteType() === 'NWNN';
  }

  toText(value: string): string | null {
    return value ? value.toUpperCase() : null;
  }

  changeType(type: any) {
    if (type == "CN") {
      this.cn_quotation = true;
      this.endorsement = false;
      this.isEndorsement = false;
    }
    if (type == "ENDT") {
      this.cn_quotation = false;
      this.endorsement = true;
      this.isEndorsement = true;
    }
  }

  goNext() {
    this.nextButtonClicked = true;
    let idType = this.issuanceForm.get('idType')?.value;
    let coverNoteType = this.issuanceForm.get('cnoteType')?.value;

    if (coverNoteType === 'NWOO/RN' && idType === 'NRIC' && !this.custAge) {
      const nricValue = this.issuanceForm?.controls['idNumberText']?.value;
      this.custAge = this.getCalculateAge(nricValue);
    }
    
    if((coverNoteType ==='NWOO/RN') && (!this.isRTP) && ((this.custAge ?? 0) < 16 || (this.custAge ?? 0) > 99) 
    && idType === "NRIC") {
      this.openPopupAge("custAge");
      return;
    }

    if (this.isEndorsement) {
      let endorsementType = this.issuanceForm.controls['endorsementType'].value;
      if (endorsementType === 'ENDT04' && this.checkEndtChanges()) {
        this.showOkMessage("Kindly make changes to proceed for endorsement.");
        return;
      }
    } else if (!this.isCoverNoteNWOO() && !this.isRTP) {
      this.issuanceForm.get('vehicleNo').setValue('NA');
    }

    if (this.isFormValid()) {

      let issuanceFormData = this.issuanceForm.getRawValue(); 
      let pdpaFormData = this.pdpaForm.getRawValue();
      let declarationInfo = {};
      if (this.isEndorsement || this.isRTP) {
        declarationInfo = {
          issuance: { ...issuanceFormData, cnoteDate: new Date().toISOString().substring(0, 10) },
          pdpa: pdpaFormData,
          isRTP: this.isRTP,
          isEndorsement: this.isEndorsement
        };
      }

	    if (this.updateQuotation) {
        let verifiedCNoteType = (!this.isEndorsement && !this.isRTP) ? this.verifyCnoteType() : null;
        declarationInfo = {
          issuance: { 
            ...issuanceFormData,
            cnoteType: verifiedCNoteType, 
            cnoteDate: new Date().toISOString().substring(0, 10),
            equotationNo: this.issuanceInfo?.equotationNo, 
            equotationCreatedDate: this.issuanceInfo?.equotationCreatedDate,
            updateVersion: this.issuanceInfo?.updateVersion,
            //AGIC-51059
            effectiveDate: (issuanceFormData?.cnoteType && issuanceFormData?.cnoteType === 'NWNN') ? null : this.parseAndFormatDate(issuanceFormData.effectiveDate),
            expiryDate: (issuanceFormData?.cnoteType && issuanceFormData?.cnoteType === 'NWNN') ? null : this.parseAndFormatDate(issuanceFormData.expiryDate),
            ...(this.previousPolicyNo && { //AGIC-49522
              prevPolicyNo: this.previousPolicyNo
            })
          },
          pdpa: pdpaFormData,
          isRTP: this.isRTP,
          isEndorsement: this.isEndorsement
        };
      } 
      else {
        let htgeExpDate = this.store.selectSnapshot<any>(state => state.SatMotorState?.expiredPolicyDetails?.expiryDate);
        let statePrevExpDate = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step1?.issuance?.issuance?.prevExpDate);
        let prevExpDate = htgeExpDate ? htgeExpDate : statePrevExpDate;
        declarationInfo = {
          issuance: { 
            ...issuanceFormData, 
            cnoteType: (!this.isEndorsement && !this.isRTP) ? this.verifyCnoteType() : null, 
            cnoteDate: new Date().toISOString().substring(0, 10),
            prevExpDate: prevExpDate,
            effectiveDate: (issuanceFormData?.cnoteType && issuanceFormData?.cnoteType === 'NWNN') ? null : this.parseAndFormatDate(issuanceFormData.effectiveDate),
            expiryDate: (issuanceFormData?.cnoteType && issuanceFormData?.cnoteType === 'NWNN') ? null : this.parseAndFormatDate(issuanceFormData.expiryDate),
            ...(this.isEndorsement && {
              endtEffectiveDate: this.parseAndFormatDate(issuanceFormData.endtEffectiveDate),
              endtExpiryDate: this.parseAndFormatDate(issuanceFormData.endtExpiryDate),
              defaultEndtEffectiveDate: this.defaultEndtEffectiveDate,
              defaultEndtExpiryDate: this.defaultEndtExpiryDate
            }),
            ...(this.previousPolicyNo && { //AGIC-49522
              prevPolicyNo: this.previousPolicyNo
            })
          },
          pdpa: pdpaFormData,
          isRTP: this.isRTP,
          isEndorsement: this.isEndorsement
        };
      }

      this.store.dispatch(new STORE_DECLARATION(declarationInfo));
      
      let activeSelectionPopup = null;
      if (!this.isEndorsement && !this.isRTP) {
        this.traceLog('verifyCnoteType', this.verifyCnoteType());
        this.traceLog('isActiveQuotation', this.isActiveQuotation);
        this.traceLog('isRenewal', this.isRenewal);
        this.traceLog('previousPolicyDetails', this.previousPolicyDetails);

        activeSelectionPopup = this.store.selectSnapshot<any>(state => state.SatMotorState.activeSelectionPopup);
        this.traceLog('activeSelectionPopup', activeSelectionPopup);
      }

      if (this.isRTP) {
        this.router.navigate(['rtp/summary'], {
          queryParamsHandling: 'preserve',
        });
      } 
      else if (this.isEndorsement) {
        let endtUpdatedData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step2?.endtUpdatedData);
        let endtUpdatePolData = this.store.selectSnapshot <any>(state => state.SatMotorState?.endtHtgePol);
        if (endtUpdatedData) {
          endtUpdatedData = {
            ...endtUpdatedData,
            endtEffectiveDate: this.parseAndFormatDate(issuanceFormData.endtEffectiveDate),
            endtExpiryDate: this.parseAndFormatDate(issuanceFormData.endtExpiryDate),
            servicetax: endtUpdatePolData?.servicetax,
            servicetaxPercentage: endtUpdatePolData?.servicetaxPercentage
          }
        }

        this.store.dispatch(new UPDATE_ENDORSEMENT_STEP2({
          isReset: false,
          cngeNote: endtUpdatedData
        })).subscribe(() => {
          this.router.navigate(['endorsement/endorsement-details'], {
            queryParamsHandling: 'preserve',
          });
        });

      } 
      else if ((this.isRenewal || this.isActiveQuotation) && this.verifyCnoteType() != 'NWOO') {
        this.traceLog('isRenewalChecking', '');
        let clientDetails = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step2);
        const einvoiceConsentValue = this.pdpaForm.get('consentDetails.einvoiceConsentInd')?.value;

        if (einvoiceConsentValue && !this.isAllMandatoryFilled()) {
          this.traceLog('clientDetails checking', '');
          this.navigateToCP(issuanceFormData);
        } else if (clientDetails?.idType1 === 'OLD_IC' && clientDetails?.idType2 !== 'NRIC') {
          this.traceLog('idType2 is not NRIC', '');
          this.navigateToCP(issuanceFormData);
        } else {
          let cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.data?.step3?.coverage?.coveragePremiumPayload?.cngeNote ?? null);
          if (!cngeNote) {
            cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote?? null);
            if (!cngeNote) {
              cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step1?.activeQuotation?.cngeNote ?? null);
              if (!cngeNote) {
                cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.previousPolicyDetails);
              }
            }
          }

          if (this.store.selectSnapshot<any>(state => state.SatMotorState?.isCancelReplaceCoverNote)) {
            this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: cngeNote, operator: this.operator })).subscribe(statePremium => {
              this.checkMakeModelExist(cngeNote, statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote);
            });
          } else {
            const formData = this.issuanceForm.getRawValue();
  
            const { effectiveDate, expiryDate } = this.issuanceForm.getRawValue();
            let latestEffDate = effectiveDate ? this.datePipe.transform(effectiveDate, 'yyyy-MM-dd') : null;
            let latestExpDate = expiryDate ? this.datePipe.transform(expiryDate, 'yyyy-MM-dd') : null;
  
            this.traceLog('ismRefNo not found', '');
            let payload = {
              productType: cngeNote?.productCode,
              idType: cngeNote?.clientPartner.idType1,
              idNo1: cngeNote?.clientPartner.idValue1,
              idNo2: cngeNote?.clientPartner.idValue2,
              vehicleUse: cngeNote?.riskList?.[0]?.vehicleUse || this.vehicleUseProductMap[formData.productCode] || "",
              vehicleNo: cngeNote?.riskList?.[0]?.vehicleNo,
              vehicleClass: cngeNote?.riskList?.[0]?.vehicleClass,
              chassisNo: cngeNote?.riskList?.[0]?.vehicleChassis,
              coverCode: cngeNote?.riskList?.[0]?.coverList?.[0]?.coverCode,
              previousNcdVehicle: cngeNote?.riskList?.[0]?.prevNcdVeh || formData.vehicleNo,
              previousNcdInsurer: cngeNote?.riskList?.[0]?.prevNcdInsurer
            };
        
            this.store.dispatch(new GET_NCD_ENQUIRY(payload)).subscribe((state) => {
              let ncdInfo = state.SatMotorState.ncdEnquiryDetails;
              const latestCoverList = state?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote?.riskList?.[0]?.coverList;
  
              if (ncdInfo) {
                this.store.dispatch(new STORE_NCD_INFO(ncdInfo));
                if (ncdInfo.ismResCode) {
                  if (this.NCD_WO_NOTIFICATION.includes(ncdInfo.ismResCode)) {
                    this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: this.updateCalculatePremiumPayload(cngeNote, latestCoverList, latestEffDate, latestExpDate, ncdInfo), operator: this.operator })).subscribe(statePremium => {
                      let coverage = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step3?.coverage);
                      let riskList = statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote?.riskList;
                      for (let rl of riskList) {
                        for (let cl of rl?.coverList) {
                          if (coverage?.coverageType) {
                            this.store.dispatch(new PATCH_STEP3("coverageType", { ncdPercentage: cl?.ncdPercentage, ncdAmount: cl?.ncdAmount }));
                          }
                        }
                      }
                      this.checkMakeModelExist(cngeNote, statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote);
                    });
                  }
                  else {
                    this.dialogService.open(OkMessageComponent, {
                      disableClose: true,
                      width: "400px", data: { message: ncdInfo.errMsg }
                    }).afterClosed().subscribe((result) => {
                      this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: this.updateCalculatePremiumPayload(cngeNote, latestCoverList, latestEffDate, latestExpDate, ncdInfo), operator: this.operator })).subscribe(statePremium => {
                        let coverage = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step3?.coverage);
                        let riskList = statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote?.riskList;
                        for (let rl of riskList) {
                          for (let cl of rl?.coverList) {
                            if (coverage?.coverageType) {
                              this.store.dispatch(new PATCH_STEP3("coverageType", { ncdPercentage: cl?.ncdPercentage, ncdAmount: cl?.ncdAmount }));
                            }
                          }
                        }
                        this.checkMakeModelExist(cngeNote, statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote);
                      });
                    });
                  }
                } else {
                  if(ncdInfo.errMsg){
                    this.dialogService.open(OkMessageComponent, {
                      disableClose: true,
                      width: "400px", data: { message: ncdInfo.errMsg }
                    }).afterClosed().subscribe((result) => {
                      this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: this.updateCalculatePremiumPayload(cngeNote, latestCoverList, latestEffDate, latestExpDate, ncdInfo), operator: this.operator })).subscribe(statePremium => {
                        this.store.dispatch(new PATCH_STEP3("coverageType", { ncdPercentage: 0, ncdAmount: 0 }));
                        this.checkMakeModelExist(cngeNote, statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote);
                      });
                    });
                  }else{
                    this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: this.updateCalculatePremiumPayload(cngeNote, latestCoverList, latestEffDate, latestExpDate, ncdInfo), operator: this.operator })).subscribe(statePremium => {
                      this.store.dispatch(new PATCH_STEP3("coverageType", { ncdPercentage: 0, ncdAmount: 0 }));
                      this.checkMakeModelExist(cngeNote, statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote);
                    });
                  }
                  
                }
              } else {
                this.dialogService.open(OkMessageComponent, {
                  disableClose: true,
                  width: "400px", data: { message: "NCD Not Allowed = 0%. Unable to connect to ISM NCD System. Please retry or contact System Administrator." }
                }).afterClosed().subscribe((result) => {
                  this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: this.updateCalculatePremiumPayload(cngeNote, latestCoverList, latestEffDate, latestExpDate, ncdInfo), operator: this.operator })).subscribe(statePremium => {
                    this.store.dispatch(new PATCH_STEP3("coverageType", { ncdPercentage: 0, ncdAmount: 0 }));
                    this.checkMakeModelExist(cngeNote, statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote);
                  });
                });
              }
            });
          }

        }
      } 
      else {
        if (this.verifyCnoteType() === 'NWOO' || this.verifyCnoteType() === 'RN') {
          this.traceLog('NWOO/RN checking', '');
          const retrieveQuotation = this.store.selectSnapshot<any>(state => state.SatMotorState.retrieveQuotation ?? null);
          let cpType = this.store.selectSnapshot<any>(state => state.SatMotorState?.data?.step2?.cpType) ?? null;
          let cpAge = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step2?.clientAge);
          let idType = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step2?.idType1);
          if (cpType && cpType === 'FOUND') {
            if ( (cpAge < 16 || cpAge > 99) && (!this.isRTP) &&(idType !=="NEW_BR_NO" && idType !=="BR_NO")){
              this.openPopupAge("custAge");
              return;
            }
          }
          
          const formData = this.issuanceForm.getRawValue();

          let idNo2, vehicleUse, vehicleClass, vehicleChassis, coverCode, previousNcdInsurer, previousNcdVehicle;

          vehicleUse = this.vehicleUseProductMap[formData.productCode] || "";
      
          const activeQuotation = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step1?.activeQuotation);
          if (activeQuotation) {

            const { effectiveDate, expiryDate } = this.issuanceForm.getRawValue();
            let latestEffDate = effectiveDate ? this.datePipe.transform(effectiveDate, 'yyyy-MM-dd') : null;
            let latestExpDate = expiryDate ? this.datePipe.transform(expiryDate, 'yyyy-MM-dd') : null;

            let cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.data?.step3?.coverage?.coveragePremiumPayload?.cngeNote ?? null);
            if (!cngeNote) {
              cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote?? null);
              if (!cngeNote) {
                cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step1?.activeQuotation?.cngeNote ?? null);
                if (!cngeNote) {
                  cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.previousPolicyDetails);
                }
              }
            }

            if (this.store.selectSnapshot<any>(state => state.SatMotorState?.isCancelReplaceCoverNote)) {
                this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: cngeNote, operator: this.operator })).subscribe(statePremium => {
                  this.proceedNCDRedirection();
                });
            } else {
              if (cngeNote?.clientPartner) {
                if (cngeNote?.clientPartner?.idType1 && cngeNote?.clientPartner?.idType1 === formData.idType) {
                  idNo2 = cngeNote?.clientPartner?.idValue2;
                } else if (cngeNote?.clientPartner?.idType2 && cngeNote?.clientPartner?.idType2 === formData.idType) {
                  idNo2 = cngeNote?.clientPartner?.idValue1;
                }
              }
              
              if (cngeNote?.riskList?.length) {
                const riskList = cngeNote?.riskList?.[0];
                if (riskList) {
                  vehicleClass = riskList?.vehicleClass || "";
                  vehicleChassis = riskList?.vehicleChassis || "";
  
                  if (riskList?.coverList?.length) {
                    const coverList = riskList?.coverList?.[0];
                    coverCode = coverList?.coverCode || "";
                  }
  
                  previousNcdInsurer = riskList?.prevNcdInsurer || "";
                  previousNcdVehicle = riskList?.prevNcdVeh || "";
                }
              }
  
              this.store.dispatch(new GET_NCD_ENQUIRY({
                productType: this.issuanceForm.controls["productCode"].value,
                idType: formData.idType, 
                idNo1: formData.idNumberText, 
                idNo2: idNo2,
                vehicleUse: vehicleUse,
                vehicleNo: formData.vehicleNo, 
                vehicleClass: vehicleClass,
                chassisNo: vehicleChassis,
                coverCode: coverCode,
                previousNcdVehicle: previousNcdVehicle || formData.vehicleNo,
                previousNcdInsurer: previousNcdInsurer
              })).subscribe((state) => {
                const latestCoverList = state?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote?.riskList?.[0]?.coverList;
  
                let ncdInfo = state.SatMotorState.ncdEnquiryDetails;
                if (ncdInfo) {
                  this.store.dispatch(new STORE_NCD_INFO(ncdInfo));
                  if (ncdInfo.ismResCode) {
                    if (this.NCD_WO_NOTIFICATION.includes(ncdInfo.ismResCode)) {
                      this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: this.updateCalculatePremiumPayload(cngeNote, latestCoverList, latestEffDate, latestExpDate, ncdInfo), operator: this.operator })).subscribe(statePremium => {
                        let coverage = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step3?.coverage);
                        let riskList = statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote?.riskList;
                        for (let rl of riskList) {
                          for (let cl of rl?.coverList) {
                            if (coverage?.coverageType) {
                              this.store.dispatch(new PATCH_STEP3("coverageType", { ncdPercentage: cl?.ncdPercentage, ncdAmount: cl?.ncdAmount }));
                            }
                          }
                        }
                        this.proceedNCDRedirection();
                      });
                    }
                    else {
                      this.dialogService.open(OkMessageComponent, {
                        disableClose: true,
                        width: "400px", data: { message: ncdInfo.errMsg }
                      }).afterClosed().subscribe((result) => {
                        this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: this.updateCalculatePremiumPayload(cngeNote, latestCoverList, latestEffDate, latestExpDate, ncdInfo), operator: this.operator })).subscribe(statePremium => {
                          let coverage = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step3?.coverage);
                          let riskList = statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote?.riskList;
                          for (let rl of riskList) {
                            for (let cl of rl?.coverList) {
                              if (coverage?.coverageType) {
                                this.store.dispatch(new PATCH_STEP3("coverageType", { ncdPercentage: cl?.ncdPercentage, ncdAmount: cl?.ncdAmount }));
                              }
                            }
                          }
                          this.proceedNCDRedirection();
                        });
                      });
                    }
                  } else {
                    this.dialogService.open(OkMessageComponent, {
                      disableClose: true,
                      width: "400px", data: { message: ncdInfo.errMsg }
                    }).afterClosed().subscribe((result) => {
                      this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: this.updateCalculatePremiumPayload(cngeNote, latestCoverList, latestEffDate, latestExpDate, ncdInfo), operator: this.operator })).subscribe(statePremium => {
                        this.store.dispatch(new PATCH_STEP3("coverageType", { ncdPercentage: 0, ncdAmount: 0 }));
                        this.proceedNCDRedirection();
                      });
                    });
                  }
                } else {
                  this.dialogService.open(OkMessageComponent, {
                    disableClose: true,
                    width: "400px", data: { message: "NCD Not Allowed = 0%. Unable to connect to ISM NCD System. Please retry or contact System Administrator." }
                  }).afterClosed().subscribe((result) => {
                    this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: this.updateCalculatePremiumPayload(cngeNote, latestCoverList, latestEffDate, latestExpDate, ncdInfo), operator: this.operator })).subscribe(statePremium => {
                      this.store.dispatch(new PATCH_STEP3("coverageType", { ncdPercentage: 0, ncdAmount: 0 }));
                      this.proceedNCDRedirection();
                    });
                  });
                }
              });
            }

            return;
          }
          else {

            if (this.store.selectSnapshot<any>(state => state.SatMotorState?.isCancelReplaceCoverNote)) {
              this.proceedNCDRedirection();
            } else {
              const clientPartner = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step2);
              if (clientPartner) {
                if (clientPartner?.idType1 && clientPartner?.idType1 === formData.idType) {
                  idNo2 = clientPartner?.idValue2;
                } else if (clientPartner?.idType2 && clientPartner?.idType2 === formData.idType) {
                  idNo2 = clientPartner?.idValue1;
                }
              }
  
              const coverage = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3?.coverage);
              
              if (coverage) {
                const riskList = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3?.coverage?.vehicleDetails);
                if (riskList) {
                  vehicleClass = riskList?.vehicleClass || "";
                  vehicleChassis = riskList?.vehicleChassis || "";
                }
                const coverList = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3?.coverage?.coverageType);
                if (coverList) {
                  coverCode = coverList?.coverCode || "";
                  previousNcdInsurer = coverList?.prevNcdInsurer || riskList?.prevNcdInsurer || "";
                  previousNcdVehicle = coverList?.prevNcdVeh || riskList?.prevNcdVeh || "";
                }
              }
  
              // NWOO-N, REQUOTE
              this.store.dispatch(new GET_NCD_ENQUIRY({
                productType: this.issuanceForm.controls["productCode"].value,
                idType: formData.idType, 
                idNo1: formData.idNumberText, 
                idNo2: idNo2,
                vehicleUse: vehicleUse,
                vehicleNo: formData.vehicleNo, 
                vehicleClass: vehicleClass,
                chassisNo: vehicleChassis,
                coverCode: coverCode,
                previousNcdVehicle: previousNcdVehicle || formData.vehicleNo,
                previousNcdInsurer: previousNcdInsurer
              })).subscribe((state) => {
                let ncdInfo = state.SatMotorState.ncdEnquiryDetails;
                if (ncdInfo) {
                  this.store.dispatch(new STORE_NCD_INFO(ncdInfo));
                  if (ncdInfo.ismResCode) {
                    if (this.NCD_WO_NOTIFICATION.includes(ncdInfo.ismResCode)) {
                      this.proceedNCDRedirection();
                    }
                    else {
                      this.dialogService.open(OkMessageComponent, {
                        disableClose: true,
                        width: "400px", data: { message: ncdInfo.errMsg }
                      }).afterClosed().subscribe((result) => {
                        this.proceedNCDRedirection();
                      });
                    }
                  } else {
                    this.dialogService.open(OkMessageComponent, {
                      disableClose: true,
                      width: "400px", data: { message: ncdInfo.errMsg }
                    }).afterClosed().subscribe((result) => {
                      this.proceedNCDRedirection();
                    });
                  }
                } else {
                  this.dialogService.open(OkMessageComponent, {
                    disableClose: true,
                    width: "400px", data: { message: "NCD Not Allowed = 0%. Unable to connect to ISM NCD System. Please retry or contact System Administrator." }
                  }).afterClosed().subscribe((result) => {
                    this.proceedNCDRedirection();
                  });
                }
              });
            }
          }
        } 
        else {
          this.traceLog('NWNN/NWTR checking', '');

          if (this.isFromCCentric && this.cCentricInfo && !this.isCpStepExist) {
            let cCentricIdType = this.cCentricInfo?.cngeNoteDto?.clientPartner?.idType1 ?? this.cCentricInfo?.clientPartner?.idType1;
            let cCentricIdValue = this.cCentricInfo?.cngeNoteDto?.clientPartner?.idValue1 ?? this.cCentricInfo?.clientPartner?.idValue1;
            let cCentricCpSearchData = {
              idType: null,
              idValue: cCentricIdValue
            };

            if(cCentricIdType == IDTYPE.NRIC) {
              cCentricCpSearchData.idType = cCentricIdType;
            }

            this.store.dispatch(new STORE_IS_CCENTRIC_CP_AUTO_SEARCH(true));
            this.store.dispatch(new SHOW_SEARCH_COMPONENT_2(false));
            this.store.dispatch(new STORE_STEP2_SEARCH(cCentricCpSearchData));
          }

          this.router.navigate(['issuance/customer-partner'], {
            queryParamsHandling: 'preserve',
          });
        }
      }
    } else {
      this.logFormErrors(this.issuanceForm);
      this.issuanceForm.markAllAsTouched();
      ScrollToError.scrollToError('.ng-invalid[formControlName]');
    }
  }

  proceedNCDRedirection() {
    const retrieveQuotation = this.store.selectSnapshot<any>(state => state.SatMotorState.retrieveQuotation ?? null);
    let issuanceFormData = this.issuanceForm.getRawValue();
    let isCpStepExist = !!this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step2);

    if (retrieveQuotation) {
      let cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step1?.activeQuotation?.cngeNote ?? null);
      this.checkMakeModelExist(cngeNote, null);
    } else {
      if((this.isRequote || this.policyDetails?.renewCase || this.updateQuotation) && isCpStepExist) {
        this.router.navigate(['issuance/customer-partner']);
      }else {
        if (isCpStepExist) {
          this.loadingService.startLoading();
          const time$: Observable<number> = timer(500);
          this.subscription = time$.subscribe(val => {
            this.router.navigate(['issuance/customer-partner']);
            this.loadingService.stopLoading();
            this.subscription.unsubscribe();
          });
        } else {
          this.performCPSearch(issuanceFormData);
        }
      }
    }
  }

  isFormValid() {
    if (this.isEndorsement || this.isRTP) {
      return this.issuanceForm.valid;
    
    } else {
      if (this.verifyCnoteType() === 'NWNN' || this.verifyCnoteType() === 'NWTR') {
        if (!this.issuanceForm.controls['cnoteType'].disabled && !this.issuanceForm.controls['cnoteType'].valid) {
          console.log("cnoteType is invalid:", this.issuanceForm.controls['cnoteType'].errors);
          return false;
        }
        if (!this.issuanceForm.controls['productCode'].disabled && !this.issuanceForm.controls['productCode'].valid) {
          console.log("productCode is invalid:", this.issuanceForm.controls['productCode'].errors);
          return false;
        }

        if (this.verifyCnoteType() === 'NWTR') {
          if (!this.issuanceForm.controls['effectiveDate'].disabled && !this.issuanceForm.controls['effectiveDate'].valid) {
            console.log("effectiveDate is invalid:", this.issuanceForm.controls['effectiveDate'].errors);
            return false;
          }

          if (!this.issuanceForm.controls['expiryDate'].disabled && !this.issuanceForm.controls['expiryDate'].valid) {
            console.log("expiryDate is invalid:", this.issuanceForm.controls['expiryDate'].errors);
            return false;
          }
        }
      } else {
        return this.issuanceForm.valid;
      }
    }
    
    return true;
  }

  checkEndtChanges() {
    let issuanceFormData = this.issuanceForm.getRawValue(); 

    let defaultEndtEffectiveDate = this.parseAndFormatDate(this.defaultEndtEffectiveDate);
    let defaultEndtExpiryDate = this.parseAndFormatDate(this.defaultEndtExpiryDate);
    let currentEndtEffectiveDate = this.parseAndFormatDate(issuanceFormData.endtEffectiveDate);
    let currentEndtExpiryDate = this.parseAndFormatDate(issuanceFormData.endtExpiryDate);

    let defaultPeriod = defaultEndtEffectiveDate + defaultEndtExpiryDate;
    let currentEndtPeriod = currentEndtEffectiveDate + currentEndtExpiryDate;

      if (defaultPeriod === currentEndtPeriod) {
        return true;
      }
      return false;
  }

  parseAndFormatDate(dateString) {
    if (!dateString) {
      return dateString;
    }
  
    let parsedDate = new Date(dateString);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate.toISOString().split('T')[0];
    } else {
      return this.parseDateWithMoment(dateString);
    }
  }

  parseDateWithMoment(dateString) {
    const parsedDate = moment(dateString, moment.ISO_8601, true);
    if (!parsedDate.isValid()) {
      return dateString;
    }
    return parsedDate.format('YYYY-MM-DD');
  }

  checkMakeModelExist(cngeNote: any, latestCalculatePremiumResponse) {
    let einvoiceConsentInd =  this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step1?.issuance?.pdpa?.consentDetails?.einvoiceConsentInd);
    let step2 =  this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step2);

    if(einvoiceConsentInd && (!step2?.clientTinNo || !step2?.clientEmail || !step2?.clientMobileCode1 || !step2?.clientMobileNo1)){
      this.router.navigate(["/issuance/customer-partner"]);
    } else if(!cngeNote?.riskList[0].vehModelNvic || cngeNote?.riskList[0].coverList?.length === 0) {
      this.traceLog('vehicle model not found', '');
      this.router.navigate(['issuance/coverage'], {
        queryParamsHandling: 'preserve',
      });
    } else {
      if(latestCalculatePremiumResponse){
        this.store.dispatch(new STORE_EXTRA_COVER_SUMMARY(latestCalculatePremiumResponse));
      }
      this.traceLog('mandatory checking passed', '');
      this.router.navigate(['issuance/summary'], {
        queryParamsHandling: 'preserve',
      });
    }
  }

  traceLog(data: string, value?: any) {
    console.log(`[INFO TRACE] ${data}${value != '' ? ' = ' + value : ''}`);
  }

  verifyCnoteType() {
    let cnoteType = this.issuanceForm.controls['cnoteType'].value;

    if (cnoteType === 'NWOO/RN') {
      const activeQuotation = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step1?.activeQuotation);
      const previousPolicyDetails = this.store.selectSnapshot<any>(state => state.SatMotorState.previousPolicyDetails);
      const requoteQuotation = this.store.selectSnapshot<any>(state => state.SatMotorState.requoteQuotation);
      const cancelReplaceData = this.store.selectSnapshot<any>(state => state.SatMotorState.data?.cancellationRes);
      const isCancelReplace = cancelReplaceData?.cancelReplaceInd;

      if (activeQuotation) {
        cnoteType = activeQuotation.cngeNote?.cnoteType;
      }

      if (previousPolicyDetails) {
          cnoteType = previousPolicyDetails.cnoteType || 'RN';
      }

      if(requoteQuotation){
        cnoteType = requoteQuotation.cnoteType;
      }

      if (this.updateQuotation) {
        cnoteType = this.updateQuotation.cnoteType;
      }

      if(isCancelReplace) {
        cnoteType = cancelReplaceData.cnoteType;
      }

      if (!activeQuotation && !previousPolicyDetails && !this.updateQuotation && !requoteQuotation && !isCancelReplace) {
        cnoteType = 'NWOO'
      }

    }

    return cnoteType;
  }

  logFormErrors(form: FormGroup) {
    Object.keys(form.controls).forEach(field => {
      const control = form.get(field);
      if (control.errors) {
        console.log(`Field: ${field}, Errors: `, control.errors);
      }
    });
  }


  goToSelectAgentCode() {
    console.log('goToSelectAgentCode..');

    if(this.showBackButton()) {
      this.store.dispatch(new STORE_AGENT_ADDITIONAL(null)).subscribe(() => {
        this.router.navigate(['agent-selection'], {
          queryParamsHandling: 'preserve',
          });
      });
    } else {
      this.store.dispatch(new RESET_MOTOR_STATE()).subscribe((state) => { 
        this.router.navigate(['agent-selection'], {
          queryParamsHandling: 'preserve',
        });
      });
    }
  }

  consentChange(event: any) {
    localStorage.setItem("eInvoice_consent", event.value);
  }

  onChangeIdNo() {
    console.log('onChangeIdNo..');

    this.hasShownProductError = false;
    const nricValue = this.issuanceForm?.controls['idNumberText']?.value;
    const idType = this.issuanceForm?.controls['idType']?.value;
    this.custAge = (idType === 'NRIC' && nricValue && nricValue != '') ? this.getCalculateAge(nricValue) : null;
    this.performSearchQuotation(false);
  }

  onChangeVehicleNo(type) {
    console.log(`[VehicleNo] Event: ${type}`);

    if (this.vehicleSearchTimeout !== undefined) {
      clearTimeout(this.vehicleSearchTimeout);
    }

    this.vehicleSearchTimeout = window.setTimeout(() => {
      console.log(`[VehicleNo] Search triggered: (${type})`);
      if (this.isRTP) {
        this.performRTPVehicleSearch();
      } else if (this.isEndorsement) {
        this.performEndtVehicleSearch();
      } else {
        this.hasShownProductError = false;
        this.performSearchQuotation(true);
      }
    }, 300); // debounce
  }

  performEndtVehicleSearch() {
    if (this.issuanceForm.controls['vehicleNo'].valid) {
      const operator = this.store.selectSnapshot(state => state.UserState.user.userId);
      let vehicleNo = this.issuanceForm.controls['vehicleNo'].value;
      if (vehicleNo != "") {
        const param = {
          "operator": operator,          
          "cngeNote": {
            "productType": "MT",
            "vehicleNo": vehicleNo 
          }
        };

        this.store.dispatch(new SEARCH_ENDT_VEHICLE(param)).subscribe((res) => {
          let endtError = (res && res.SatMotorState?.endorsement?.step1?.endtVehicleSearchError) ?? null;
          let endtPolicy = (res && res.SatMotorState?.endorsement?.step1?.endtVehicleData) ?? null;

          if (endtPolicy && endtPolicy.mkagAgent) {
            this.store.dispatch(new GET_PRODUCT_LIST(
              { 
                lob: 'MT', agentCode: endtPolicy.mkagAgent.agentCode, productCode: endtPolicy.productCode 
              }
            )).subscribe((state) => {
              const endorsementList = state.SatMotorState?.lov?.endorsementList;

              if (!endorsementList || endorsementList.length === 0) {
                this.showOkMessage("Vehicle No doesn't exist");
                this.clearVehicleNo();
                this.endtVehicleFound = false;
              }
            });
          }

          if (endtError && endtError.message) {
            console.log("message: " + endtError.message);
            this.showOkMessage(endtError.message);
            this.clearVehicleNo();
          }
        });
      }
    }
  }

  showOkMessage(messageData: any) {
    this.okMessageModal = this.dialogService.open(OkMessageComponent, {
      disableClose: true,
      width: '400px',
      data: {
        message: messageData
      }
    });
  }

  showEndtOkMessage(messageData: any) {
    this.okMessageEndtModal = this.dialogService.open(OkMessageComponent, {
      disableClose: true,
      width: '400px',
      data: {
        message: messageData
      }
    });
    this.okMessageEndtModal.afterClosed().subscribe(() => {
      this.showEndtDateValidateError = false;
    });
  }

  performRTPVehicleSearch() {
    const operator = this.store.selectSnapshot(state => state.UserState.user.userId);
    let vehicleNo = this.issuanceForm.controls['vehicleNo'].value;
    if (vehicleNo != "") {

      //Reset state before search
      this.store.dispatch(new ROADTAX_SEARCH({
        isReset: true
      }));

      const param = {
        isReset: false,
        operator: operator,
        cngeNote: {
          productType: "MT",
          vehicleNo: vehicleNo
        }
      };

      this.store.dispatch(new ROADTAX_SEARCH(param)).subscribe((res) => {
        let rptError = (res && res.SatMotorState?.rtp?.step1?.rtpVehicleSearchError) ?? null;
        let rtpPolicy = (res && res.SatMotorState?.rtp?.step1?.rtpPolicy) ?? null;
        this.isRTPDataExist = rtpPolicy ? true : false;

        if (rtpPolicy && !rptError) {
          let policy = res.SatMotorState.rtp?.step1?.rtpPolicy?.data?.cngeNoteDto;
          if (policy && policy.mkagAgent) {
            this.filteredProductList = [
              {
                code: policy.productCode,
                descp: policy.productName
              }
            ];
            this.populateRTPForm(policy);
            this.store.dispatch(new SET_PRODUCT_CODE_DESCRIPTION({ descp: policy.productName }));
          }
        } else {
          if (rptError && rptError.message) {
            this.clearVehicleNo();

            console.log("message: " + rptError.message);
            this.showOkMessage(rptError.message);
          }
        }
      });
    }
  }

  clearVehicleNo() {
    const vehicleNoControl = this.issuanceForm.controls['vehicleNo'];
    vehicleNoControl.clearValidators();
    vehicleNoControl.setValue('');
    vehicleNoControl.setValidators([
      Validators.required, Validators.pattern('^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d-]{1,20}$')
    ]);
    vehicleNoControl.updateValueAndValidity();
    vehicleNoControl.markAsUntouched();
  }

  populateRTPForm(policy: any) {
    this.issuanceForm.patchValue({
      vehicleNo: policy.vehicleNo ?? policy.riskList[0].vehicleNo,
      prevPolicyNo: policy.previousPolicyNo ?? policy.policyNo,
      productCode: policy.productCode,
      specialVehicleInd: policy.specialVehicleInd,
      effectiveDate: policy.effectiveDate,
      expiryDate: policy.expiryDate
    });

    this.previousPolicyNo = policy.previousPolicyNo ?? policy.policyNo;
  }

  performSearchQuotation(isRNSearch) {
    console.log('performSearchQuotation()');
    const idValid = this.issuanceForm.controls['idNumberText'].valid;
    const vehicleValid = this.issuanceForm.controls['vehicleNo'].valid;
    const vehicleDisabled = this.issuanceForm.controls['vehicleNo'].disabled;

    if (isRNSearch) {
      this.isRNSearchComplete = true;
      const idValue = this.issuanceForm.controls['idNumberText'].value;
      if (idValue) {
        this.issuanceForm.controls['idType'].setValue('NRIC');
      }
    }
    console.log('vehicleValid:', vehicleValid);

    if ((isRNSearch || idValid) && (vehicleValid || vehicleDisabled)) {
      this.resetStore();
      let vehicleNo = this.issuanceForm.controls['vehicleNo'].value;
      let idNo = isRNSearch ? "" : this.issuanceForm.controls['idNumberText'].value;
      let cnoteType = this.issuanceForm.controls['cnoteType'].value;

      if (cnoteType === 'NWOO/RN' || cnoteType === 'RN' || cnoteType === 'NWOO') {
        console.log('vehicleNo:', vehicleNo);
        if (vehicleNo != "" && (isRNSearch || idNo != "")) {
          const param: any = {
            vehicleNo: vehicleNo,
            agentCode: this.agentData.agentCode,
            ...(isRNSearch ? {} : { idNo: idNo })
          };

          const prevPolicyparam = {
            "vehicleNo": this.issuanceForm.controls['vehicleNo'].value,
            "agentCode": this.agentData.agentCode,
          };

          this.store.dispatch(new SEARCH_ACTIVE_QUOTATION(param)).subscribe((res) => {
            
            if (res.SatMotorState.motor?.step1?.activeQuotation) { 
              if(res.SatMotorState.motor?.step1?.activeQuotation.cngeNote.cnoteType === 'NWOO'){
                let payload = {
                  ...res.SatMotorState.motor?.step1?.activeQuotation,
                  cngeNote: {
                    ...res.SatMotorState.motor?.step1?.activeQuotation?.cngeNote
                  }
                };
              
                // Remove  previousPolicyNo 
                delete payload.cngeNote.previousPolicyNo;
                this.store.dispatch(new UPDATE_ACTIVE_QUOTATION(payload));
              }

              this.issuanceForm.controls['vehicleNo'].disable();
              this.activeQuotationDetails = res.SatMotorState.motor?.step1?.activeQuotation;
              this.isActiveQuotation = true;
              if(res.SatMotorState.motor?.step1?.activeQuotation.cngeNote.cnoteType == 'RN'){
                this.isRenewal = true;
                this.issuanceForm.controls["effectiveDate"].disable();
              }else{
                this.isRenewal = false;
              }
              let activeQuotation =  this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step1?.activeQuotation);
              this.openPopupActiveQuotation('populateActiveQuotationDetails', activeQuotation, param)
              this.isVehicleIdNoExist = true;
              this.isSecondSearchComplete = true;
            } else {
              // Previous Policy Search
              this.issuanceForm.controls['vehicleNo'].enable();
              this.searchPreviousPolicy(param);
            }
            this.isCommercial = res.SatMotorState.opportunityId;
          });
        } else {
          this.isVehicleIdNoExist = true;
          this.isSecondSearchComplete = true;
        }
      }
    } else {
      if (!vehicleValid) {
        const vehicleControl = this.issuanceForm.get('vehicleNo');

        if (vehicleControl.hasError('required')) {
          console.log('Error: Vehicle number is required.');
        }
        if (vehicleControl.hasError('pattern')) {
          console.log(
            'Error: Vehicle number format is invalid. Entered value:',
            vehicleControl.value
          );
        }
      }
    }
  }

  searchActiveQuotation(param){
    this.resetStore();
    this.isVehicleIdNoExist = true;
    this.store.dispatch(new SEARCH_ACTIVE_QUOTATION(param)).subscribe((res) => {
      if (res.SatMotorState.motor?.step1?.activeQuotation) { 
        this.issuanceForm.controls['vehicleNo'].disable();
        this.activeQuotationDetails = res.SatMotorState.motor?.step1?.activeQuotation;
        this.isActiveQuotation = true;
        if(res.SatMotorState.motor?.step1?.activeQuotation.cngeNote.cnoteType == 'RN'){
          this.isRenewal = true;
          this.issuanceForm.controls["effectiveDate"].disable();
        }else{
          this.isRenewal = false;
        }
        let activeQuotation = res.SatMotorState.motor?.step1?.activeQuotation;
        this.openPopupActiveQuotation('populateActiveQuotationDetails', activeQuotation, param)
        this.issuanceForm.patchValue({
          vehicleNo: activeQuotation?.cngeNote?.vehicleNo,
          prevPolicyNo: activeQuotation?.cngeNote?.previousPolicyNo || activeQuotation?.cngeNote?.refPolicyNo,
          effectiveDate: activeQuotation?.cngeNote?.effectiveDate,
          expiryDate: activeQuotation?.cngeNote?.expiryDate,
          productCode: activeQuotation?.cngeNote?.productCode,
          idNumberText: activeQuotation?.cngeNote?.clientPartner?.idValue1
        });

      } else {
        // Previous Policy Search
        this.issuanceForm.controls['vehicleNo'].enable();
        this.searchPreviousPolicy(param);
      }
      this.isCommercial = res.SatMotorState.opportunityId;
    });
  }

  searchPreviousPolicy(param) {
    console.log('searchPreviousPolicy..');

    this.store.dispatch(new GET_PREVIOUS_POLICY_NO(param)).subscribe((state) => {
      this.isVehicleIdNoExist = true;
      let previousPolicyDetails = state.SatMotorState.previousPolicyDetails;
      let previousPolicyDetailsError = state.SatMotorState.previousPolicyDetailsError;
      
      if (previousPolicyDetails) {
        this.policyDetails = state.SatMotorState.policyDetails;
        this.previousPolicyDetails = previousPolicyDetails;
        this.isCommercial = state.SatMotorState.opportunityId;
        this.isRenewal = this.verifyCnoteType?.() === 'RN';
        this.isVehicleIdNoExist = true;

        const fieldsToDisable = [
          'cnoteType',
          'vehicleNo',
          'idType',
          'idNumberText',
          'productCode'
        ];

        if (this.isRenewal) {
          fieldsToDisable.push('effectiveDate');
        } else {
          this.issuanceForm.controls["effectiveDate"].enable({ emitEvent: false });
        }

        this.disableFields(fieldsToDisable);
        this.previousPolicyNo = previousPolicyDetails.previousPolicyNo || previousPolicyDetails.refPolicyNo;

        if(this.queryParams.policyNo){
          this.issuanceForm.patchValue({
            idType: previousPolicyDetails.clientPartner.idType1,
            idNumberText: previousPolicyDetails.clientPartner.idValue1
          });
        }

        const partner = previousPolicyDetails?.clientPartner;
        if (partner?.idType1 && partner?.idValue1) {
          this.issuanceForm.controls['idType'].setValue(partner.idType1);
          this.issuanceForm.controls['idNumberText'].setValue(partner.idValue1, { emitEvent: false });
        } else {
          console.warn("Missing idType1 or idValue1 in clientPartner");
        }

        this.issuanceForm.patchValue({
          vehicleNo: previousPolicyDetails.vehicleNo,
          prevPolicyNo: previousPolicyDetails.previousPolicyNo || previousPolicyDetails.refPolicyNo,
          effectiveDate: previousPolicyDetails.effectiveDate,
          expiryDate: previousPolicyDetails.expiryDate,
          productCode: previousPolicyDetails.productCode,
        });

        previousPolicyDetails = {
          ...previousPolicyDetails,
          newAgentCode: this.agentData.agentCode,
          mkagAgent: {
            ...previousPolicyDetails.mkagAgent,
            agentCode: this.agentData.agentCode
          }
        }

        this.store.dispatch(new COPY_CNGE_INFO_RENEWAL(previousPolicyDetails)).subscribe(state => { });
        let vehicleDetails = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.vehicleDetails);

        if(vehicleDetails?.makeModel && vehicleDetails?.vehModelNvic){
          let cngeNoteUpdated = previousPolicyDetails;
          let riskList = cngeNoteUpdated.riskList[0];
          if(riskList.coverList[0]){
            const { coverDto, ...coverList } = riskList.coverList[0];
  
            riskList = {
              ...riskList,
              coverList : [coverList]
            };
            
            if (riskList.makeModelDesc) {
              vehicleDetails = {
                ...vehicleDetails,
                makeModelDesc: riskList.makeModelDesc
              }
            }
          }

          //optional package
          if (riskList?.coverList?.[0]?.subCovPackage) {
            riskList = {
              ...riskList,
              coverList: [{
                ...riskList.coverList[0],
                coverDto: { extCovPackageSelected: riskList.coverList[0].subCovPackage }
              }]
            };
          }

          cngeNoteUpdated = {
            ...cngeNoteUpdated,
            riskList: [riskList]
          };

          if (previousPolicyDetails) {
            const previousPolicyVehCap = this.store.selectSnapshot<any>((state) => state.SatMotorState?.policyDetails?.htgePol?.riskList[0]?.vehicleCapacity);
            if (previousPolicyVehCap){
              cngeNoteUpdated = {
                ...cngeNoteUpdated,
                riskList: [{
                  ...cngeNoteUpdated?.riskList[0],
                  vehicleCapacity: previousPolicyVehCap
                }]
              };
              this.store.dispatch(new PATCH_STEP3("vehicleDetails", { vehicleCapacity: previousPolicyVehCap }));
            }
          }

          //SatMotorState.motor.step3.coverage.coveragePremium
          if (riskList?.coverList?.[0]) {
            this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: cngeNoteUpdated, operator: this.operator })).subscribe((state) => {
              if (state) {
                const cngeNote = state?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote;
                if (cngeNote) {
                  const region = cngeNote["region"];
                  const riskList = cngeNote["riskList"];
                  if (riskList?.length) {
                    for (let riskListItem of riskList) {

                      const { avEmSiMin, avEmSiMax, avWmSiMin, avWmSiMax } = riskListItem;
                      const coverList = riskListItem["coverList"];
                      if (coverList?.length) {
                        for (let coverListItem of coverList) {
                          this.store.dispatch(new UPDATE_COVERAGE_TYPE(this.transform(coverListItem, false)));
                          let makeModelSiMin = region === "E" ? avEmSiMin : avWmSiMin , makeModelSiMax = region === "E" ? avEmSiMax : avWmSiMax;
                          const { sumInsured } = coverListItem;
                          if (makeModelSiMin && makeModelSiMax) {
                            this.store.dispatch(new PATCH_STEP3("coverageType", { avInd: sumInsured >= makeModelSiMin && sumInsured <= makeModelSiMax }));
                            this.store.dispatch(new PATCH_STEP3("vehicleDetails", { avInd: sumInsured >= makeModelSiMin && sumInsured <= makeModelSiMax }));
                            this.store.dispatch(new PATCH_STEP3("coveragePremium", { 
                              ...state?.SatMotorState?.motor?.step3?.coverage?.coveragePremium,
                              cngeNote: {
                                ...cngeNote, 
                                riskList: [{
                                  ...riskListItem, avInd: sumInsured >= makeModelSiMin && sumInsured <= makeModelSiMax,
                                  coverList: [{
                                    ...coverListItem, avInd: sumInsured >= makeModelSiMin && sumInsured <= makeModelSiMax
                                  }]
                                }]
                              }
                            }));
                            cngeNoteUpdated = {
                              ...cngeNoteUpdated,
                              riskList: [{
                                ...cngeNoteUpdated?.riskList?.[0], avInd: sumInsured >= makeModelSiMin && sumInsured <= makeModelSiMax,
                                coverList: [{
                                  ...cngeNoteUpdated.riskList?.[0]?.coverList?.[0], avInd: sumInsured >= makeModelSiMin && sumInsured <= makeModelSiMax
                                }]
                              }]
                            };
                          }
                        }
                      }
                    }
                  }

                  if (cngeNote) {
                    let previousSubCoverList = this.store.selectSnapshot<any>((state) => state.SatMotorState?.previousPolicyDetails?.riskList?.[0].coverList?.[0].subCoverList);
                    this.recalculatePremium(cngeNote ,previousSubCoverList,cngeNoteUpdated);
                  }
                }
              }
            });;
          }

          //previous policy empty
          if (!riskList?.coverList?.[0] || previousPolicyDetails?.cnoteType === 'NWOO') {
            this.store.dispatch(new DELETE_COVERAGE("")).subscribe((state) => {});
            this.isRenewal = false;
            this.issuanceForm.controls["effectiveDate"].enable();
            if ('idNo' in param && param.idNo) {
              if (this.policyDetails?.vixRequired)
                this.searchVIX({ cngeNote: { vehicleNo: param.vehicleNo } }, false);
            }
          }
        } else {
          if (previousPolicyDetails.cnoteType === 'NWOO') {
            this.isRenewal = false;
            this.issuanceForm.controls["effectiveDate"].enable();
            if ('idNo' in param && param.idNo) {
              if (this.policyDetails?.vixRequired)
                this.searchVIX({ cngeNote: { vehicleNo: param.vehicleNo } }, false);
            }
          }
        }
        this.isSecondSearchComplete = true;

      } else {
        if (previousPolicyDetailsError &&
          previousPolicyDetailsError.message &&
          !previousPolicyDetailsError.message.includes("No result") && !previousPolicyDetailsError.message.includes("Invalid Vehicle No")) {
          this.clearVehicleNo();
          this.isVehicleIdNoExist = false; //when validation failed clear vehicleNo
          this.showOkMessage(previousPolicyDetailsError.message);
          this.isSecondSearchComplete = false;
          this.isRNSearchComplete = false;
        } else {
          if ('idNo' in param && param.idNo) {
            this.searchVIX({ cngeNote: { vehicleNo: param.vehicleNo } }, true);
            this.isSecondSearchComplete = true;
          } else {
            this.isSecondSearchComplete = false;
            if (this.cCentricInfo) {
              let idType = this.cCentricInfo?.cngeNoteDto?.clientPartner?.idType1 ?? this.cCentricInfo?.clientPartner?.idType1;
              let idValue = this.cCentricInfo?.cngeNoteDto?.clientPartner?.idValue1 ?? this.cCentricInfo?.clientPartner?.idValue1;

              if (idType && idValue) {
                this.issuanceForm.patchValue({
                  idType: this.cCentricInfo?.cngeNoteDto?.clientPartner?.idType1 ?? this.cCentricInfo?.clientPartner?.idType1,
                  idNumberText: this.cCentricInfo?.cngeNoteDto?.clientPartner?.idValue1 ?? this.cCentricInfo?.clientPartner?.idValue1
                });

                this.performSearchQuotation(false);
              }
            }
          }
        }
      }
    });
  }

  searchVIX(param, isReset) {
    this.store.dispatch(new SEARCH_VIX(param)).subscribe((res) => {
      if (res.SatMotorState.motor?.step1?.searchVIX) {
        let searchVIX = res.SatMotorState.motor?.step1?.searchVIX;

        if (searchVIX?.cngeNote?.riskList && searchVIX?.cngeNote?.riskList.length) {
          let riskItem = searchVIX?.cngeNote?.riskList[0];

          let vixExpDate;
          if (riskItem?.polExpDate) {
            vixExpDate = new Date(riskItem?.polExpDate);
          }

          let effDate;
          if (vixExpDate) {
            effDate = new Date();
            if (vixExpDate > effDate) {
              effDate = vixExpDate;
              effDate.setDate(vixExpDate.getDate() + 1);
            }
          }

          let expDate;
          if (effDate) {
            expDate = new Date(effDate);
            expDate.setFullYear(expDate.getFullYear() + 1); // add 1 year
            expDate.setDate(expDate.getDate() - 1); // subtract 1 day
          }

          this.issuanceForm.patchValue({
            effectiveDate: effDate || null,
            expiryDate: expDate || null,
          });
  
          if (["01", "11"].includes(riskItem.vehicleClass)) {
              if (["11", "12", "13", "62"].includes(riskItem.vehicleUse)) {
                this.issuanceForm.patchValue({ productCode: "082101" });
              }
          } else if (["02", "12"].includes(riskItem.vehicleClass)) {
              if (["01", "04"].includes(riskItem.vehicleUse)) {
                this.issuanceForm.patchValue({ productCode: "080100" });
              } else if (["02"].includes(riskItem.vehicleUse)) {
                  this.issuanceForm.controls["productCode"].enable();
              } else if (["03"].includes(riskItem.vehicleUse)) {
                this.issuanceForm.patchValue({ productCode: "080300" });
              }
          }

          
          let payloadPremium = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor?.step3?.coverage?.coveragePremium ?? null);
          if (!payloadPremium) {
            payloadPremium = this.store.selectSnapshot<any>((state) => state.SatMotorState.data?.step3?.coverage?.coveragePremiumPayload ?? null);
          }
          let updatedPayload = {
            ...payloadPremium,
            cngeNote: {
              ...payloadPremium?.cngeNote,
              productCode: this.issuanceForm.controls["productCode"].value,
            }
          };
          
          this.store.dispatch(new PATCH_STEP3("coveragePremium", updatedPayload)).subscribe((state) => {
            let vhd = state.SatMotorState.motor?.step3?.coverage?.vehicleDetails;
            if (vhd?.vehicleUse && riskItem?.vehicleUse && vhd?.vehicleUse !== riskItem?.vehicleUse) {
              this.store.dispatch(new PATCH_STEP3("vehicleDetails", { cngeRiskDrvrDtoList: [] })).subscribe((state) => {
                let dn = state.SatMotorState.motor?.step3?.coverage?.extracover?.driverNameDetails;
                if (dn) {
                  this.store.dispatch(new PATCH_STEP3("extracover", { driverNameDetails: { } }));
                }
              });
            }
          });
        }
      } else {
        if (isReset) {
          this.issuanceForm.controls["productCode"].enable();
          this.issuanceForm.controls["effectiveDate"].enable();
          this.isRenewal = false;
          this.reset();

          if (this.queryParams?.cnoteType && this.queryParams?.productCode) {
            this.issuanceForm.controls['productCode'].setValue(this.queryParams?.productCode);
          }
        } else {
          this.issuanceForm.controls["productCode"].enable();
          this.issuanceForm.controls["effectiveDate"].enable();
        }
      }
    });
  }

  previousPolicyErrorPopup(popup_type: any, error: any) {
    this.openPreviousPolicyError = this.dialogService.open(PreviousPolicyErrorPopupComponent, {
      ariaLabel: "A simple dialog",
      width: '400px',
      showCloseIcon: false,
      disableClose: true,
      data: {
        popup_type: popup_type,
        popup_error: error
      },
    });
  }

  openPopupEnquiry(popup_type: any) {
    this.componentDialogRef1 = this.dialogService.open(EnquiryPopupComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: "360px",
      maxWidth: "90vw",
      data: { popup_type: popup_type },
    });
  }

  openPopupActiveQuotation(popup_type: any, data: any, param) {
    this.openPreviousPolicyError = this.dialogService.open(PreviousPolicyErrorPopupComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: "500px",
      maxWidth: "500px",
      data: { popup_type: popup_type, activeQuotationDetails: data },
    });

    this.openPreviousPolicyError.afterClosed().subscribe((result) => {
      this.store.dispatch(new ACTIVE_SELECTION_POPUP(result)).subscribe(state => { });

      if (result != 'Y' && data?.cngeNote) {
        const updatedCngeNote = this.setNullForTags(data.cngeNote);
        updatedCngeNote.contractId = null;

        data = {
          ...data,
          cngeNote: updatedCngeNote
        };

        this.store.dispatch(new UPDATE_ACTIVE_QUOTATION(data));
      }

      const partner = data?.cngeNote?.clientPartner;
      if (partner?.idType1 && partner?.idValue1) {
        this.issuanceForm.controls['idType'].setValue(partner.idType1);
        this.issuanceForm.controls['idNumberText'].setValue(partner.idValue1, { emitEvent: false });
      } else {
        console.warn("Missing idType1 or idValue1 in clientPartner");
      }

      if (data?.cngeNote?.effectiveDate) {
        if (result === 'Y') {
          this.issuanceForm.controls['effectiveDate'].setValue(data.cngeNote.effectiveDate);
        } else {
          if (this.isRenewal) { //AGIC-49522
            let policyExpiryDate = new Date(data.htgePol.expiryDate);
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            if (policyExpiryDate >= today) {
              policyExpiryDate.setDate(policyExpiryDate.getDate() + 1);
            } else {
              policyExpiryDate = today;
            }

            const formattedDate = `${policyExpiryDate.getFullYear()}-${(policyExpiryDate.getMonth() + 1).toString().padStart(2, '0')}-${policyExpiryDate.getDate().toString().padStart(2, '0')}`;
            this.issuanceForm.controls['effectiveDate'].setValue(formattedDate);
          } else {
            const today = new Date();
            const localDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
            this.issuanceForm.controls['effectiveDate'].setValue(localDate);
          }
        }
      } 
      if (data?.cngeNote?.expiryDate) {
        if (result === 'Y') {
          this.issuanceForm.controls['expiryDate'].setValue(data.cngeNote.expiryDate);
        }
      }
      if (data?.cngeNote?.productCode) {
        this.issuanceForm.controls['productCode'].setValue(data.cngeNote.productCode);
      }

      if(data?.cngeNote?.previousPolicyNo){
        this.previousPolicyNo = data?.cngeNote?.previousPolicyNo;
      }

      if (data?.cngeNote?.cnoteType === 'NWOO' || data?.cngeNote?.cnoteType === 'RN') {
        this.store.dispatch(new COPY_CNGE_INFO_RENEWAL(data?.cngeNote)).subscribe(state => { });
        this.store.dispatch(new SET_RETRIEVE_QUOTATION(result === 'Y')).subscribe(state => { });
      }
      
      //AGIC-49528 removed result == 'Y'
      if (data?.cngeNote?.cnoteType != 'NWOO') {
        this.store.dispatch(new COPY_CNGE_INFO_RENEWAL(data?.cngeNote)).subscribe(state => { });
        
        let vehicleDetails = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.vehicleDetails);
        let expiryDateVal = this.issuanceForm.controls['expiryDate'].value; 
        expiryDateVal = this.parseAndFormatDate(expiryDateVal);

        if (vehicleDetails?.makeModel && vehicleDetails?.vehModelNvic) {
          let cngeNoteUpdated = data?.cngeNote;
          let riskList = cngeNoteUpdated.riskList[0];
          const { coverDto, ...coverList } = riskList.coverList[0];
          riskList = {
            ...riskList,
            coverList: [coverList]
          };

          if (riskList?.coverList?.[0]?.subCovPackage) {
            riskList = {
              ...riskList,
              coverList: [{
                ...riskList.coverList[0],
                coverDto: { extCovPackageSelected: riskList.coverList?.[0]?.subCovPackage }
              }]
            };
          }

          cngeNoteUpdated = {
            ...cngeNoteUpdated,
            ...((expiryDateVal && result != 'Y') && {
              expiryDate: expiryDateVal
            }),
            riskList: [riskList]
          };

          this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: cngeNoteUpdated, operator: this.operator })).subscribe(statePremium => {
            let latestCoveragePremium =  statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote;          
           
            if(latestCoveragePremium){
              let previousSubCoverList = this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step1?.activeQuotation?.cngeNote?.riskList?.[0].coverList?.[0].subCoverList);
              this.recalculatePremium(latestCoveragePremium, previousSubCoverList, cngeNoteUpdated);
            }
           });;
          
        }

      } else {
      }

      this.disableFields(['cnoteType', 'vehicleNo', 'idType', 'idNumberText', 'productCode']);
    });
  }

  setNullForTags(obj: any) {
    if (!obj || typeof obj !== 'object') return obj;

    const tagsToNullify = ['contractId', 'riskId', 'coverId', 'subcoverId', 'updateVersion', 'proposalNo'];
    const dateFieldsUpdate = ['cnoteDate'];
    const resetFields = ['createBy', 'updateBy', 'issueBy','createDate', 'updateDate', 
      'printDate', 'proposalDate', 'proposalGenDate', 'radarTransDate', 'printCount', 
      'printSeries', 'proposalType', 'cnoteStatus', 'progress', 'coverageRemark',
    ];

    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    const newObj = Array.isArray(obj) ? [] : {};

    for (const key in obj) {
      if (tagsToNullify.includes(key)) {
        newObj[key] = null;
      } else if (dateFieldsUpdate.includes(key)) {
        newObj[key] = formattedDate;
      } else if (resetFields.includes(key)) {
        continue;
      } else if (typeof obj[key] === 'object') {
        newObj[key] = this.setNullForTags(obj[key]);
      } else {
        newObj[key] = obj[key];
      }
    }

    return newObj;
  }

  reset() {
    if (this.queryParams.idType && this.queryParams.idValue) {
      this.resetFields(['productCode', 'prevPolicyNo']);
      this.updateCurrentDate();
    } else {
      this.resetFields(['productCode', 'prevPolicyNo', 'effectiveDate', 'expiryDate']);
    }
    
    this.previousPolicyNo = "";
  }

  resetFields(fieldList: string[]) {
    fieldList.forEach(field => {
      if (this.issuanceForm.controls[field]) {
        this.issuanceForm.controls[field].setValue("", { emitEvent: false });
        this.issuanceForm.controls[field].setErrors(null, { emitEvent: false });
        this.issuanceForm.controls[field].markAsPristine();
        this.issuanceForm.controls[field].markAsUntouched();
        this.issuanceForm.controls[field].updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  disableFields(fieldList: string[]) {
    fieldList.forEach(field => {
      if (this.issuanceForm.controls[field]) {
        this.issuanceForm.controls[field].disable({ emitEvent: false });
      }
    });
  }

  openPopup(popup_type: any) {
    this.componentDialogRef = this.dialogService.open(PdpaPopupComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: '400px',
      data: { popup_type: popup_type },
    });

  }

  openPopupAge(popup_type: any) {
    
        this.componentDialogRefs = this.dialogService.open(SummaryPopupComponent, {
          ariaLabel: "A simple dialog",
          showCloseIcon: false,
          disableClose: true,
          width: '400px',
          data: { popup_type: popup_type },
        });
      }


  onChangeProduct(code: any) {
    if (code === '082100') {
      this.openPopupEnquiry('popupProductMotorcycle');
    }
    this.store.dispatch(new RESET_SUBSEQUENT_PAGE_DATA());

    if (this.isIssuance) {
      if (this.verifyCnoteType() !== 'NWNN') {
        let effectiveDateControl = this.issuanceForm.controls['effectiveDate'];
        let expiryDateControl = this.issuanceForm.controls['expiryDate'];
  
        if (effectiveDateControl.value && expiryDateControl.value && this.isEffectiveDateValidation) {
          this.validateDate();
        }
      }
      
      for (let i = 0; i < this.lovproductConfig.length; i++) {
        this.productAccessListData = this.lovproductConfig[i];
        this.lovPC = Object.keys( this.productAccessListData)[0]; 
      
          if (this.lovPC === code) {
           this.lovGeo =this.productAccessListData[this.lovPC].geocodingEnableSat;
           this.emailCheck = this.productAccessListData[this.lovPC].emailCheckEnableSat;
          }
      }

      if(this.issuanceForm?.controls['idType']?.value === "NEW_BR_NO" || this.issuanceForm?.controls['idType']?.value === "BR_NO") //AGIC-45992
      {
        if (this.lovproductConfig){
          this.lovproductConfig.map(item => {
            if(Object.keys(item)[0] === code) {
              this.isEinvoiceEnabled = item[Object.keys(item)[0]]?.einvoiceEnabled;
            }
          });
        this.eInvoiceEnableInd(this.isEinvoiceEnabled);
        }
      } else {
        this.eInvoiceEnableInd(true);
      }
    }
  }

  onChangeFormValue(code: any) {
    this.resetStore();
    this.issuanceForm.controls['vehicleNo'].reset();
    if (code == 'NWOO' || code === 'NWOO/RN') {
      this.issuanceForm.controls['vehicleNo'].setValidators([
        Validators.required, Validators.pattern('^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d-]{1,20}$')
      ]);
      this.issuanceForm.controls['vehicleNo'].updateValueAndValidity();
      this.isSecondSearchComplete = false;
    } else {
      this.issuanceForm.controls['vehicleNo'].clearValidators();
      this.issuanceForm.controls['vehicleNo'].updateValueAndValidity();
      this.issuanceForm.controls["effectiveDate"].enable({ emitEvent: false });
      this.issuanceForm.controls['effectiveDate'].updateValueAndValidity({ emitEvent: false });
      this.isSecondSearchComplete = true;
      //this.issuanceForm.controls.vehicleNo.setValidators(null);
    }

    if (this.queryParams.productCode) {
      this.issuanceForm.controls['productCode'].setValue(this.queryParams.productCode);
    }

    if(code === "NWOO/RN" && this.queryParams.cnoteType && this.queryParams.productCode && this.queryParams.idType && this.queryParams.idValue) {
      this.issuanceForm.controls['idType'].setValue(this.queryParams.idType);
      this.issuanceForm.controls['idNumberText'].setValue(this.queryParams.idValue);
    }
  }

  noSpaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const hasSpace = /\s/.test(control.value);
      return hasSpace ? { wrongFormat: true } : null;
    };
  }

  nricValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      //check if exactly 12 digits long and only numbers
      const pattern = /^\d{12}$/;
      if (!pattern.test(value)) {
        return { wrongFormat: true };
      }

      const year = +value.substring(0, 2);
      const month = +value.substring(2, 4);
      const day = +value.substring(4, 6);

      const currentYear = new Date().getFullYear();
      const fullYear = (year > currentYear % 100) ? 1900 + year : 2000 + year;

      const date = new Date(fullYear, month - 1, day);

      if (
        date.getFullYear() === fullYear &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
      ) {
        return null; // Valid NRIC
      }

      return { wrongFormat: true };
    };
  }

  newBrNoValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      const pattern = /^\d{1,12}$/;
      if (!pattern.test(value) || value.length < 12) {
        return { invalidBrNo: true };
      }

      const year = +value.substring(0, 4);
      const currentYear = new Date().getFullYear();

      if (year > currentYear) {
        return { invalidBrNo: true };
      }

      return null;
    };
  }

  expiryDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      this.showDateValidateError = false;
      this.showLapsedError = false;
      this.dateValidateError = '';

      const formGroup = control.parent as FormGroup;
      if (!formGroup) return null;

      const effectiveDate = formGroup.get('effectiveDate')?.value;
      const expiryDate = control.value;

      if (effectiveDate && expiryDate && new Date(expiryDate) < new Date(effectiveDate)) {
        this.showDateValidateError = true;
        this.dateValidateError = 'Expiry date cannot be before effective date';
        return { dateMismatch: true };
      }
      return null;
    };
  }

  performCPSearch(issuanceFormData: any) {
    this.store.dispatch(new SHOW_SEARCH_COMPONENT_2(true));

    const { idType, idNumberText: idValue } = issuanceFormData;
    const productType = "MT";
    const agentCode = this.agentData.agentCode;
    const operator = this.store.selectSnapshot(state => state.UserState.user.userId);
    const data = { idType, idValue, agentCode, operator, productType };

    this.lookupIdSearch(data, issuanceFormData);
  }

  lookupIdSearch(data: {}, issuanceFormData: any) {
    this.store.dispatch(new GET_CUSTOMER_PARTNER(data)).subscribe(state => {
      this.cpDetails = state.SatMotorState.data.step2.store;
      this.checkCPScreen(issuanceFormData, data);
      if(this.cpDetails){
        this.store.dispatch(new STORE_ONE_ALLIANZ_DATA(this.cpDetails))
      }
    });
  }

  checkCPScreen(issuanceFormData: any, data: any) {
    const details = this.cpDetails;
    let cpType = "NOT_FOUND";

    if (details) {
      if (details.updateCustomerPartner) {
        this.isCompOrCustInfoIncomplete = this.isContactInfoIncomplete = this.isCorrespondenceInfoIncomplete = true;
        cpType = "INCOMPLETE";
      } else {
        cpType = this.isAllMandatoryFilled() ? "FOUND" : "INCOMPLETE";
      }
    }

    this.store.dispatch(new STORE_STEP2_CP_SCREEN({
      cpScreen: cpType,
      isCompOrCustInfoIncomplete: this.isCompOrCustInfoIncomplete,
      isContactInfoIncomplete: this.isContactInfoIncomplete,
      isCorrespondenceInfoIncomplete: this.isCorrespondenceInfoIncomplete
    }));

    let searchData = {
      ...data,
      clientAddressType: this.idTypeConfig[data.idType].clientAddressType,
      clientType: this.idTypeConfig[data.idType].clientType,
    };
    this.store.dispatch(new STORE_STEP2_SEARCH(searchData));
    this.store.dispatch(new SHOW_SEARCH_COMPONENT_2(false));


    if (cpType === 'FOUND') {
      let cpType =this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step2?.idType1);
      let cpAge = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step2?.clientAge);
      if ( (cpAge < 16 || cpAge > 99) && (!this.isRTP) &&(cpType !=="NEW_BR_NO" && cpType !=="BR_NO")){
        this.openPopupAge("custAge");
        return;
      }

    }

    this.store.dispatch(new GET_POSTCODE_LOV({
      listTypes: ["clientPostcodeList"],
      agentCode: this.agentData.agentCode,
      productType: "COMM",
      productCode: issuanceFormData.productCode
    })).subscribe(() => {

      this.router.navigate(['issuance/customer-partner']);
    });
  }

  navigateToCP(issuanceFormData: any) {
    this.store.dispatch(new SHOW_SEARCH_COMPONENT_2(true));

    const { idType, idNumberText: idValue } = issuanceFormData;
    const productType = "MT";
    const agentCode = this.agentData.agentCode;
    const operator = this.store.selectSnapshot(state => state.UserState.user.userId);
    const data = { idType, idValue, productType, agentCode, operator };

    this.store.dispatch(new STORE_STEP2_CP_SCREEN({
      cpScreen: 'INCOMPLETE',
      isCompOrCustInfoIncomplete: this.isCompOrCustInfoIncomplete,
      isContactInfoIncomplete: this.isContactInfoIncomplete,
      isCorrespondenceInfoIncomplete: this.isCorrespondenceInfoIncomplete
    }));

    let searchData = {
      ...data,
      clientAddressType: this.idTypeConfig[data.idType].clientAddressType,
      clientType: this.idTypeConfig[data.idType].clientType,
    };
    this.store.dispatch(new STORE_STEP2_SEARCH(searchData));
    this.store.dispatch(new SHOW_SEARCH_COMPONENT_2(false));

    this.store.dispatch(new GET_POSTCODE_LOV({
      listTypes: ["clientPostcodeList"],
      agentCode: this.agentData.agentCode,
      productType: "COMM",
      productCode: issuanceFormData.productCode
    })).subscribe(() => {

      this.router.navigate(['issuance/customer-partner']);
    });
  }

  isAllMandatoryFilled() {
    const details = this.cpDetails;

    if (this.cpDetails || Object.keys(this.cpDetails).length === 0) {
      this.cpDetails = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step2);
    }

    let eInvoiceConsentControl = this.pdpaForm.get('consentDetails.einvoiceConsentInd');
    let cpMandatoryFilled = this.cpMandatoryFilledService.checkCPMandatoryFilled(this.cpDetails, this.emailCheck, eInvoiceConsentControl.value);

    this.isCompOrCustInfoIncomplete = cpMandatoryFilled.isCompOrCustInfoIncomplete;
    this.isContactInfoIncomplete = cpMandatoryFilled.isContactInfoIncomplete;
    this.isCorrespondenceInfoIncomplete = cpMandatoryFilled.isCorrespondenceInfoIncomplete;

    return !(this.isCompOrCustInfoIncomplete || this.isContactInfoIncomplete || this.isCorrespondenceInfoIncomplete);
  }

  resetStore() {
    this.store.dispatch(new RESET_MOTOR_STATE()).subscribe((state) => { });
    this.store.dispatch(new RESET_PREVIOS_POLICY_DETAILS()).subscribe((state) => { });
    this.isRenewal = false;
    this.isActiveQuotation = false;
  }

  validateDate() {
    this.showDateValidateError = false;
    this.showLapsedError = false;
    this.dateValidateError = '';
    
    console.log("cNoteType: "+this.verifyCnoteType());
    if (this.verifyCnoteType() === 'NWOO' || this.verifyCnoteType() === 'NWTR' || this.verifyCnoteType() === 'RN') {
      const policy = this.store.selectSnapshot<any>(state => state.SatMotorState?.expiredPolicyDetails);
      const { productCode, effectiveDate, expiryDate } = this.issuanceForm.getRawValue();
      
      let cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step1?.activeQuotation?.cngeNote ?? null);
      if (!cngeNote) {
        cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.previousPolicyDetails);
      }

      const vehicleNo = (this.verifyCnoteType() != 'NWNN' && this.verifyCnoteType() != 'NWTR') ? this.issuanceForm.controls['vehicleNo'].value ?? null : null;
      const payload = {
        cngeNoteDto: {
          cnoteType: this.verifyCnoteType(),
          productCode,
          effectiveDate: effectiveDate ? this.datePipe.transform(effectiveDate, 'yyyy-MM-dd') : null,
          expiryDate: expiryDate ? this.datePipe.transform(expiryDate, 'yyyy-MM-dd') : null,
          mkagAgent: { agentCode: this.agentData.agentCode },
          ...(vehicleNo && {
            vehicleNo
          }),
          ...((this.verifyCnoteType() === 'RN' && cngeNote) && {
            proposalNo: cngeNote.proposalNo
          })
        },
        htgePol: policy ?? null
      };
    
      this.store.dispatch(new VALIDATE_POI_DATE(payload)).subscribe(state => {
        const { success, message } = state.SatMotorState.poiValidateResult || {};
        if (success || (message && message.includes('lapsed'))) {
          this.showDateValidateError = false;
          this.showLapsedError = false;
          this.dateValidateError = '';

          let payloadPremium = state.SatMotorState.data?.step3?.coverage?.coveragePremiumPayload ?? null;
          if (!payloadPremium && this.isRenewal) {
            let cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step1?.activeQuotation?.cngeNote ?? null);
            if (!cngeNote) {
              cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.previousPolicyDetails);
            }
            if(!cngeNote) {
              cngeNote = state.SatMotorState.updateQuotation ?? null;
            }

            if (cngeNote) {
              payloadPremium = {
                cngeNote: {
                  ...cngeNote
                }
              }
            }
          }
          if (payloadPremium && payloadPremium.cngeNote) {
            const formattedExpiryDate = moment(expiryDate).startOf('day'); 
            const currentExpiryDate = moment(payloadPremium.cngeNote.expiryDate).startOf('day');
          
            if (!currentExpiryDate.isSame(formattedExpiryDate, 'day')) {
              let cngeNoteClone = { ...payloadPremium.cngeNote };
          
              cngeNoteClone.effectiveDate = moment(effectiveDate).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
              cngeNoteClone.expiryDate = formattedExpiryDate.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
              cngeNoteClone.operator = this.operator;
          
              payloadPremium = {
                ...payloadPremium,
                cngeNote: cngeNoteClone,
                operator: this.operator
              };

              if (payloadPremium?.cngeNote?.riskList && payloadPremium?.cngeNote?.riskList?.length) {
                payloadPremium = {
                  ...payloadPremium,
                  cngeNote: {
                    ...payloadPremium.cngeNote,
                    riskList: [{
                      ...payloadPremium.cngeNote?.riskList[0],
                      ncdEffDate: cngeNoteClone.effectiveDate
                    }]
                  }
                };

                if (payloadPremium?.cngeNote?.riskList?.[0]?.coverList && payloadPremium?.cngeNote?.riskList?.[0]?.coverList?.length) {
                  payloadPremium = {
                    ...payloadPremium,
                    cngeNote: {
                      ...payloadPremium.cngeNote,
                      riskList: [{
                        ...payloadPremium.cngeNote?.riskList[0],
                        coverList: [{
                          ...payloadPremium.cngeNote?.riskList?.[0]?.coverList[0],
                          ncdEffDate: cngeNoteClone.effectiveDate
                        }]
                      }]
                    }
                  };
                }
              }
          
              this.updatePremiumCalculation(payloadPremium);
            }
          }

          let activeQuotation = state.SatMotorState.motor?.step1?.activeQuotation ?? null;
          let updateQuotation = state.SatMotorState.updateQuotation ?? null;

          if ((activeQuotation || updateQuotation) && !(payloadPremium && payloadPremium.cngeNote)) {
            let cngeNote = activeQuotation?.cngeNote || updateQuotation;
            if (cngeNote.cnoteType == 'NWOO' || cngeNote.cnoteType == 'NWTR') {

              let latestEffDate, latestExpDate;
              const formattedExpiryDate = moment(expiryDate).startOf('day');
              const currentExpiryDate = moment(cngeNote.expiryDate).startOf('day');

              if (!currentExpiryDate.isSame(formattedExpiryDate, 'day')) {
                const { effectiveDate, expiryDate } = this.issuanceForm.getRawValue();
                latestEffDate = effectiveDate ? this.datePipe.transform(effectiveDate, 'yyyy-MM-dd') : null;
                latestExpDate = expiryDate ? this.datePipe.transform(expiryDate, 'yyyy-MM-dd') : null;
              }

              let vehicleDetails = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.vehicleDetails);
              let latestActiveCoveragePremium = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.coveragePremium); //summary page & click back
              let hasVehicleModel = (vehicleDetails?.makeModel && vehicleDetails?.vehModelNvic) ? true : false;

              if (hasVehicleModel) {
                let cngeNoteUpdated = cngeNote;
                let riskList = cngeNoteUpdated.riskList[0];
                const { coverDto, ...coverList } = riskList.coverList[0];
                riskList = {
                  ...riskList,
                  coverList: [
                    {
                      ...coverList,
                      ...(latestExpDate && {
                        expiryDate: latestExpDate,
                        effectiveDate: latestEffDate
                      })
                    }
                  ]
                };

                //only for cr14 optional package
                if (riskList.coverList[0].subCovPackage) {
                  riskList = {
                    ...riskList,
                    coverList: [{
                      ...riskList.coverList[0],
                      coverDto: { extCovPackageSelected: riskList.coverList[0].subCovPackage }
                    }]
                  };
                }

                if(latestActiveCoveragePremium?.cngeNote?.riskList?.[0]?.coverList?.[0]?.coverDto){
                  riskList = {
                    ...riskList,
                    coverList: [{
                      ...riskList.coverList[0],
                      coverDto: latestActiveCoveragePremium?.cngeNote?.riskList?.[0]?.coverList?.[0]?.coverDto
                    }]
                  };
                }

                cngeNoteUpdated = {
                  ...cngeNoteUpdated,
                  ...(latestExpDate && {
                    expiryDate: latestExpDate,
                    effectiveDate: latestEffDate
                  }),
                  riskList: [riskList]
                };

                this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: cngeNoteUpdated, operator: this.operator })).subscribe(statePremiumLvl2 => {
                  let latestCoveragePremium =  statePremiumLvl2?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote;          
           
                  if(latestCoveragePremium) {

                    let riskList = latestCoveragePremium?.riskList;
                    for (let rl of riskList) {
                      for (let cl of rl?.coverList) {
                        this.store.dispatch(new PATCH_STEP3("coverageType", cl));
                      }
                    }

                    let previousSubCoverList;
                    
                    if (activeQuotation) {
                      previousSubCoverList = activeQuotation?.cngeNote?.riskList?.[0].coverList?.[0].subCoverList;
                    } else if (updateQuotation) {
                      previousSubCoverList = updateQuotation?.riskList?.[0].coverList?.[0].subCoverList;
                    }
                    this.recalculatePremium(latestCoveragePremium, previousSubCoverList, cngeNoteUpdated);
                  }
                });
              }
            }

          }

          if ((message && message.includes('lapsed'))) {
            this.showDateValidateError = !message.includes('lapsed');
            this.showLapsedError = message.includes('lapsed');
            this.dateValidateError = message;
          }

        } else if (message) {
          this.showDateValidateError = !message.includes('lapsed');
          this.showLapsedError = message.includes('lapsed');
          this.dateValidateError = message;
        }

        this.isEffectiveDateValidation = this.showDateValidateError;
      });
    }
    
  }

  updatePremiumCalculation(payloadPremium: any) {
    this.store.dispatch(new STORE_PREMIUM_CALCULATION_PAYLOAD(payloadPremium)).subscribe({
      next: () => {
        this.store.dispatch(new CALCULATE_PREMIUM(payloadPremium)).subscribe(statePremium => {
          let latestCoveragePremium =  statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote;
          if(latestCoveragePremium){
            //for Alim customer without MRW
            if (latestCoveragePremium.alimCustomerIndi) {
              payloadPremium = {
                ...payloadPremium,
                riskList: [{
                  ...payloadPremium.riskList[0],
                  coverList: [{
                    ...payloadPremium.riskList[0].coverList[0],
                    coverDto: {
                      ...payloadPremium.riskList[0].coverList[0].coverDto|| {},
                      subCovList: latestCoveragePremium.riskList[0].coverList[0].coverDto.subCovList
                    }
                  }]
                }]
              };

              this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: payloadPremium, operator: this.operator })).subscribe((state) => {
                this.postUpdatePremiumCalculation(state?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote);
              });
            } else {
              this.postUpdatePremiumCalculation(latestCoveragePremium);
            }
          }
         });;
      }
    });
  }

  postUpdatePremiumCalculation(cngeNote: any) {
    this.store.dispatch(
      new PATCH_STEP3("coverageType", {
        ...cngeNote?.riskList?.[0]?.coverList?.[0],
        ncdEffDate: (cngeNote?.cnoteType && cngeNote?.cnoteType === 'NWNN') ? new Date() : cngeNote?.riskList?.[0]?.ncdEffDate
      }),
    );
    this.store.dispatch(
      new PATCH_STEP3("vehicleDetails", {
        ncdEffDate: (cngeNote?.cnoteType && cngeNote?.cnoteType === 'NWNN') ? new Date() : cngeNote?.riskList?.[0]?.ncdEffDate
      }),
    );
    this.store.dispatch(new STORE_EXTRA_COVER_SUMMARY(cngeNote));
  }

  checkDisabled() {
    const { pdpaCheck, consentDetails } = this.pdpaForm.getRawValue();

    if (this.isIssuance) {
      let hasError = false;

      if (this.verifyCnoteType() === 'NWNN' || this.verifyCnoteType() === 'NWTR') {
        if (!this.issuanceForm.controls['cnoteType'].disabled && !this.issuanceForm.controls['cnoteType'].valid) {
          hasError = true;
        }
        if (!this.issuanceForm.controls['productCode'].disabled && !this.issuanceForm.controls['productCode'].valid) {
          hasError = true;
        }
        if (this.verifyCnoteType() === 'NWTR') {
          if (!this.issuanceForm.controls['effectiveDate'].disabled && !this.issuanceForm.controls['effectiveDate'].valid) {
            hasError = true;
          }

          if (!this.issuanceForm.controls['expiryDate'].disabled && !this.issuanceForm.controls['expiryDate'].valid) {
            hasError = true;
          }
        }
      } else {
        Object.keys(this.issuanceForm.controls).forEach(field => {
          const control = this.issuanceForm.controls[field];
          if (control.errors) {
            hasError = true;
          }
        });

        if (!hasError) {
          const productCodeCtrl = this.issuanceForm?.controls?.['productCode'];
          if (productCodeCtrl && productCodeCtrl.value && Array.isArray(this.filteredProductList)) {
            const productCode = productCodeCtrl.value;

            const exists = this.filteredProductList.some(
              (p: any) => p?.code === productCode
            );

            if (!exists) {
              hasError = true;

              if (productCodeCtrl?.disabled && !this.hasShownProductError) {
                this.hasShownProductError = true;
                this.showOkMessage("Unable to proceed due to product name error, please contact branch");
              }
            }
          }
        }
      }

      if (hasError 
        || !pdpaCheck
        || consentDetails.edocConsentInd == null
        || consentDetails.edocConsentInd === ""
        || consentDetails.einvoiceConsentInd == null
        || consentDetails.einvoiceConsentInd === ""
        || (this.isEmarketingConsentEnabled && (consentDetails.emarketingConsentInd == null || consentDetails.emarketingConsentInd === ""))
        || this.showDateValidateError
        || this.isEffectiveDateValidation) {
        return true;
      }
    }

    if (this.isRTP && (!this.isRTPDataExist || !pdpaCheck)) {
      return true;
    }

    if (this.isEndorsement && this.issuanceForm) {
      let endorsementType = this.issuanceForm.controls['endorsementType'].value;
      let endtEffectiveDate = this.issuanceForm.controls['endtEffectiveDate'].value;
      let endtExpiryDate = this.issuanceForm.controls['endtExpiryDate'].value;
      let invoiceConsentSelected = (consentDetails.einvoiceConsentInd == null || consentDetails.einvoiceConsentInd === "") ? false : true;

      let isEndtFieldsEmpty =
        (endorsementType === null || endorsementType === undefined || endorsementType === "") ||
        (endtEffectiveDate === null || endtEffectiveDate === undefined || endtEffectiveDate === "") ||
        (endtExpiryDate === null || endtExpiryDate === undefined || endtExpiryDate === "");

      if (!this.endtVehicleFound || !pdpaCheck || !this.issuanceForm.valid || isEndtFieldsEmpty || this.showEndtDateValidateError) {
        return true;
      }
    }

    return false;
  }

  hasErrors(): boolean {
    if (this.isEndorsement && this.issuanceForm) {
      return this.issuanceForm.hasError('required', 'endorsementType') ||
        this.issuanceForm.hasError('required', 'endtEffectiveDate') ||
        this.issuanceForm.hasError('required', 'endtExpiryDate') ||
        this.showDateValidateError ||
        this.showLapsedError;
    } else {
      return this.showDateValidateError || this.showLapsedError;
    }
  }

  switchToAlpha() {
    const payload = {
      "userId" : this.operator,
      "opportunityId": this.isCommercial,
      "agentCode": this.agentData.agentCode
    };
    this.store.dispatch(new REDIRECT_ALPHA_CCENTRIC(payload)).subscribe({});
  }

  showBackButton() {
    let data = this.agentData;
    return (!!data.customerType) || data.bancaAgent || data.sundriesAgent;
  }

  goBack() {
    this.router.navigate(['issuance/agent-additional-info']);
  }

  cancelDraft() {

    this.dialogService.open(CancelDraftModalComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      autoFocus: false,
      width: '90vw',
      maxWidth: '550px',
    })
    .afterClosed().subscribe(result => {
      if (result) {
        const data = {
          operator: this.userInfo.userId,
          cngeNote: this.isSaved
        };
        this.store.dispatch(new CANCEL_DRAFT(data)).subscribe(state => {
          if (state) {
            this.dialogService.open(SimpleModalComponent, {
              showCloseIcon: false, width: "500px", maxWidth: "500px",
              disableClose: true,
              data: { message: "Cancel Draft Success" },
            })
            .afterClosed().subscribe((result) => {
              this.store.dispatch(new GET_SWITCH_SITE("SUMMARY_SYS_URL")).subscribe((state) => {
                window.location.href = state.SatMotorState.data.switchSiteUrl;
              });       	      
            });
          }
        });
      }
    });

  }
  
  getCalculateAge(value) {
    return this.nricService.getAge(value);
  }
  eInvoiceEnableInd(isEinvoiceEnabled){ //AGIC-45992
      if (isEinvoiceEnabled) {
        this.pdpaForm.get('consentDetails.einvoiceConsentInd').enable();
      } else {
        this.pdpaForm.get('consentDetails.einvoiceConsentInd').disable();
        this.pdpaForm.get('consentDetails.einvoiceConsentInd').setValue(true);
      }
  }

  transform(value, output) {
    let tvalue = { 
      ...value
    };

    ["sumInsured", "excessAmount", "annualPremium", "basicPremium", "grossPremium", "allriderPrem", "ncdPercentage", "ncdAmount"].forEach(v => {
      tvalue = { ...tvalue, [v]: (output ? this.decimalFmt.transform(value[v]) : this.numberFmt.transform(value[v]) ) };
    });
    
    return tvalue;
  }

  hasCoverNoteAccess() {
    if (this.userInfo && this.userInfo.menuAccess) {
      if (this.userInfo.menuAccess.includes('SAT_MT_CN')) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  updateCalculatePremiumPayload(cngeNote, latestCoverList, latestEffDate, latestExpDate, ncdInfo) {

    let cngeNoteUpdated = {
      ...cngeNote, effectiveDate: latestEffDate, expiryDate: latestExpDate,
      riskList: [{
          ...cngeNote.riskList[0],
          ismRefNo: ncdInfo?.ismRefNo,
          prevNcdEffDate: ncdInfo?.currPctEffDate,
          prevNcdExpDate: ncdInfo?.currPctExpDate,
          ncdEffDate: (cngeNote?.cnoteType && cngeNote?.cnoteType === 'NWNN') ? new Date() : latestEffDate,
          nextNcdEffDate: ncdInfo?.nextNcdPctEffDate,
          nextNcdPct: ncdInfo?.nextNcdPct,
          coverList: latestCoverList || cngeNote.riskList[0].coverList
      }]
    };

    this.store.dispatch(
      new PATCH_STEP3("coverageType", {
          prevNcdEffDate: ncdInfo?.currPctEffDate,
          prevNcdExpDate: ncdInfo?.currPctExpDate,
          ncdEffDate: (cngeNote?.cnoteType && cngeNote?.cnoteType === 'NWNN') ? new Date() : latestEffDate,
          nextNcdEffDate: ncdInfo?.nextNcdPctEffDate,
          nextNcdPct: ncdInfo?.nextNcdPct
      }),
    );

    return cngeNoteUpdated;
  }

  recalculatePremium(latestCoveragePremium, previousSubCoverList, cngeNoteUpdated) {
    if (latestCoveragePremium) {
      let hasWaiver = previousSubCoverList?.some(obj => (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') && obj.subCoverPrem > 0);
      let hasSubCovPackageList = latestCoveragePremium?.riskList?.[0]?.coverList?.[0]?.coverDto?.subCovPackageList;

      //for Alim customer without MRW
      if (latestCoveragePremium.alimCustomerIndi || hasWaiver || (hasSubCovPackageList && hasSubCovPackageList.length > 0)) {
        let latestSubCovList = latestCoveragePremium?.riskList?.[0]?.coverList?.[0]?.coverDto?.subCovList

        if (hasWaiver) {
          latestSubCovList = latestSubCovList?.map(obj => {
            if (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') {
              return { ...obj, selected: true }
            }
            return obj;
          })
        } 

        cngeNoteUpdated = {
          ...cngeNoteUpdated,
          riskList: [{
            ...cngeNoteUpdated.riskList[0],
            coverList: [{
              ...cngeNoteUpdated.riskList[0].coverList[0],
              coverDto: {
                ...cngeNoteUpdated.riskList[0].coverList[0].coverDto || {},
                subCovList: latestSubCovList,
                subCovPackageList: hasSubCovPackageList || []
              }
            }]
          }]
        };

        this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: cngeNoteUpdated, operator: this.operator })).subscribe((state) => {
          const latestCngeNote = state?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote;
          this.store.dispatch(new STORE_EXTRA_COVER_SUMMARY(latestCngeNote));
          this.store.dispatch(new STORE_DRIVER_DETAILS_SUMMARY(latestCngeNote));
        });
      } else {
        this.store.dispatch(new STORE_EXTRA_COVER_SUMMARY(latestCoveragePremium));
        this.store.dispatch(new STORE_DRIVER_DETAILS_SUMMARY(latestCoveragePremium));
      }
    }
  }

  isAgentDisabled() {
    if (!this.isIssuance){
      return true;
    } else {
      if (this.isRequote || this.isDraftRecord || this.isDataFromView) {
        return true;
      }
      else {
        return false;
      }
    }
  }
}
